'use strict'

import React from 'react'
import ReactDOM from 'react-dom';

// import Dyn from '../lib/dynDataSet/dynMiscellany';
// import mediator from '../lib/dynDataSet/mediatorUtil';
// import Jed from 'jed';
import { domToCanvas as toCanvas } from 'modern-screenshot';

import ToolbarMenus, {filterMenus, samplingStatesMenuChildren, samplingDistributionMenuChildren,
    samplingPopulationMenuChildren } from '../utils/ToolbarMenus';
import Menu from './menu/Menu.jsx';
import MenuItem from './menu/MenuItem.jsx';
import SubMenu from './menu/SubMenu.jsx';
import Divider from './menu/Divider.jsx';
import ToolTip from './common/ToolTip';
import Mathjax from './common/Mathjax';
import { requireJrMode } from '../utils/Util';
const TuvaLogo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAioAAACKCAYAAACEs2F0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA\
3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWR\
vYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6\
cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9uc\
y5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly\
9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozNWU4NTU0YS0yMTk4LTRlMzMtYjQ1My1iMzJmNTBkMmRhYTciIHhtcE1NOk\
RvY3VtZW50SUQ9InhtcC5kaWQ6OUE1NTA5NkFBN0JGMTFFOTg4N0ZGNDkxRkQ3MEUyQzgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUE1NTA5NjlBN0JGMTFFOTg4N0ZGND\
kxRkQ3MEUyQzgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC\
5paWQ6ODFhOTNiN2ItYTkxYS1hOTRjLWJlZWMtYjgwOWI2YzRmZDhhIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjM1ZTg1NTRhLTIxOTgtNGUzMy1iNDUzLWIzMmY1MGQyZ\
GFhNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtjbYPwAACERSURBVHja7J0JmB1FtcdPVjKAwLwYllGWF\
xQ1gz5gZNEM6MOIqEFRQAUliGKQHUEfgk+N6EOCsm8aBTGAIiiKAWUZEXAiKI6IMhEUhtVBlDBCwARIMtbfqvtS6XRXdfetvt198/993/my9FbVXbfr36dOnRozOjoqhBBCCCFVZ\
CxvASGEEEIoVAghhBBCKFQIIYQQQqFCCCGEEEKhQgghhBAKFUIIIYQQChVCCCGEEAoVQgghhFCoEEIIIYRQqBBCCCGEQoUQQgghhEKFEEIIIYRChRBCCCEUKoQQQgghFCqEEEIIo\
VAhhBBCCKFQIYQQQgihUCGEEEIIhQohhBBCSAjG8xYQQrIyd+7cb6o/tuWdWINPKutvl8q8+OKLMjo6yqeajinK3qxsurJXK9vQ/P8/lN1r2sUtyhZXqdDjxo37t4XkhBNOoFAhh\
JROj7LteBvWYDJvwVrHy5Qdp+wAZZsm7LOnsmOVDSubr+xsZX/lrUsHh34IIXlYxlsQywregrUKiJM7jVDZNMX+Xco+bY7Zl7ePQoUQQggpijnKLle2WY5jX67sKiNaCIUKIYQQEh\
QIjM8HOM+XlR1TZkXGjBlDoUIIIYS0EW9VdkrA831V2a6lCICxY/9tFCqEkHakg7cglnG8BW3f7s9RFtINgUktCK6d2PLGOq4ezZWzfgghefiVsiUlXXuq6KDEOBDM+ltlz5dUt\
r+zabQ1+4ueeuzjKWV/MoLmVco28uy/vbJ9lH23ZZ3/+PG1GPahUCGE5OXQEq8NV/nxCdueU/YOZU/yEZHAoFf/qGefF5WdrOxi0VORAQJnZyv7jLhHMQ5plVCBJ6UOQz4UKoSQu\
uLzV0/kLSIF8J+i8wclsVzZB0XP5rF5TNnnlD2o7CJJHjbaRXROlr8ULVLqMuTTgDEqhJB2/PIlJDSvU7aOY/vlMSLF5lvKfuDYvq4UnO25jiKFQoUQQghJx5ae7ZelOMf8Jq+Rm\
wkTJtRSpAAO/RBCCCF+NnRsQxD3YynO8aBn+3qhC42AWQiUugTOUqgQQggh+Vjq2DbWI2QavNSzPehsNYiTOs3ucd1cQgghhLhxeUygBN6V4hx7e7YHC6SFFwXDPXUXKRQqhBBCSD\
oGla10bD9cdMBtEpgx5JrejKnNi0KJlLrGo1CoEEIIIfm4V9l9ju1I6rZAdIr9KO9Udo2y9R3H36NsqJkCwntS56DZJBijQgghhPh5QXRCtpMd+2yh7EZlt4nOkAxnADwp01Oc/zui\
g3JzgQRuiEdpRyhUCCGEkHTME73a8WTPfrsZS8vjovOs5OvIlUCpU6bZzCKM7Y4QQghJxRPKPlvAeU9StjhzB67ECYZ62lmkUKgQQggh2bhQ9DBNKJBW/5KsByEOpR2mHqeBQz+EE\
EKK4pWiVw/GwnwTROcieVh0YOqjNa4XFhCcpOy9TZ4HKfcPy3IAvCd1T+BGoUIIIaRMEL9xkLIPSPL6OEuU3a7sUtNZP1+zOkJwnaXsPZJvbalRZV8RPeSTKoC2kWG23Yd5YsUZf1\
OEEEICAYGC2S6nK9tRkhfxe4myPYxQWajsLTWs69E5Rcqtoqcwn5BWpKwtsShJ0KNCCCGkWSBIzhM9JJIVTN+9QdmJxstQB14j/ky08BrBc/KsskeMIEMulV+kvcja7EWhUCGEEB\
KyH7lc2T5NnAMZyk5Ttq6yL9Sgzkcom+jYDlFygGiPCQTLM1kv0M55UShUCCGEBAFf9KOjo77dTm1SpNjMUXa/ET5VZVNlH/Tsg/iVR3J3zG2eFyWzaOMtIIQQkiRUPPy3suM\
DX/Zs0bOEqsrBotPlJ4EZTT/Oe7/X5lgUChVCCCEhhQqGa07JcLrRlPth1tCnK3pLsFbPoZ59LhCdbj9bZ2yGetamaccUKoQQQooUKr3KdvGc4p/KzhQ9qwdBs3sruyLFpTG0smk\
Fb8m+yrZ0bEfm2suynnRtSt6WB8aoEEIISRQq+NJfuXJl3GZfXMpjovOM/Mb6v7tEz3z5kbJvS/L0ZQytYArvpRW6HfAgHeXZ52JlI1lFSrutdtx2QoUKkhTMLGVTzd/PzvoSc\
TDH/Ill2eeXVbkUgY6ENEWCUMGL+42Ow3DAIRGRYvM9ZduIeyXiXSsmVCCcdnBsf070ooXpO2AGzaZrg7wFhBBCXEIl5oOyU9nmjsOQdfYGz6mRd+Xvju2vqtitONaz/fvKHkr7g\
U6RkkHQ8RYQQkgm1jEfeaMxXoblyl5sg3og/8f/B4RiaGL58uX2PggqXc9x7jtTXB/eTcyQmZKwfYMK3St4UmY4tsODdG5a4RcwPwqe4YbGXhJph0+Lzt8yIukDmdOCHDLj0rQdCh\
VCCGktHcp+YrwJcS/p65UdWYN6oKO5TtlWCfW4UdnhjuNHPZ3fypTlqMvY/5GmY07iJmUDLRApGC7b0di2ph1uYtrlxMj9x/pJyIr7uOgh6t8p+5XoOKEnmrwfyHOzfULbwfn3o1Ah\
hJBywIsYKwK/LGH75jWrxxYJ27fwHI94DMzoWT9h+84pyoDhI9fwzjMVuVcQc+/z7HOO94abdPg5eK3oVZrfKcmLPK6hiYx4gU0xx+1tti1WdofogObrjJDJCuL+tk7Y9nToB0ChQg\
gh2XC5tV9sx3rExKhgOAGzejZOOP4NyvYU7WFK4jBJHvYBf6rIffqYuIe54KnwxeNknX4MRYO1hJCz5S2B++rJRvTAnlR2tbKvi15MMkTbeSH0A2AkDyGEEK83IAJc/r/09C3fED1E\
Ecf7lX3Oc9lbK1B1TJP+iGcfxKasCChS4D1ZaATE2wp2KLxU2WzRQ0IYznldFdsfhQohhBB/Z7HmDJWrPIcgDf7PlZ2hbHdl2ymbKTohGpK+uYYw/iE67qNsPiTuxHNYz+dK331LOb\
sHQzwYivmBpBs6CwnE0AFGsGBxyCoFModXako1zjF/HRodHZ1v/T/GypCZcJqyrshhCEKCK7G/yct3ix73jIvO7jfXcAU84bhe83eUfSjj9WdbdZurbGnG408QPaY46HkJ9Jp69k\
T+f8jYQMZrz7GOn++4nzjvAs+5Qpct7vyTrOfUYFjZInPvRkr8TTXbzu02lKcNNn5vKMNe5p996rfYL4SE9aosNB2bq1PFkMknjGUBYuaJkquM4NTDPftgyORZ1z1LGZdyvHkPr1\
9ynfFu/ZToYSEkt7u5LYVKwsOaEdOx2PRYQqEvh2DpNsd2ejo4+xpxgmXA2q87YyfRFemYejLWo9t0cuIQU73iniI31dgMc+2+nI+sy3z5dGUUEEWWrccc2+G5/zNSCqoi8N2DNO\
0c/z8rZxuMu9ZSSTEbgZAcQgXDHScp+1ngSy02H3plA6H/Go/X51uuE0CkeIZ8EKODJHF7V+xx40MLM78wPHdK2YUZX3DDRqdyYKTDwxevHWUc/fqeYW7SpSm/vPeK+XofiHxV29f\
oMMdMjfFajJiOYaopw4KMDzb67/4cx48kdE52htVGB7Qw5hxdVqfZqGMWD0OXeWYdEU+FOM5TdNmi5/c9Y/y5mfhd0yG9KPtFyhht51EvUFI7HzL16rTE7kjG391U614vHB0dXSq\
ENEkj8VskGzK+uDG0c1zASx0tOlC3bI72bP+OOGbMQKR4hnwwvfhKjxhygVlR95t3xkPmPYH/myA6pwqmLW+l7BXmz4kZzw9X0P+Z9xSyDC9rV4+K/VXerxp4X4JKXxD5Gm10lj6\
xEhUpri/16DUaHoxo+vNB0+F0mH0GM37BRr/wh1N2dN0Ob4rdUY+YusSJmX5ZNVTTba4/yyj2tJ3VfqY8Q+Ze+spfdNmiIiXtM+4ydWnFj2umVUZX+fpM+aabe5zUzvtl1bBNt2T\
3MPZE2jMhwbwqMcs2YMgaC/Xt0+TpMdPoC0YAlA1+p7s5tmNmy/mu++QZ8uk1H1JZF158QNlPRc8y+m3K/mUdI1Sw5MHbxT/6EAULRGJ21/ulpGH1IoNpp1qd7/w4kRLTkdlrsXS\
ZF7rrQdvu7XniH06IXmOqrDkktcjqNKalrKs9bNPn8LLk6Vh6rU5wyJTfNRwwYn4AfZanYUaGZ9Ypq2JVhlP8mIssm33+LM94nrlWV4wnpqh2vtTcsyzlS2rndhzPdEke7op7QXba\
olf97sqM1yFtRkLniyyoCMS8qMnTP+vq/CvmTblWVnma1/QAuJO6TTcfVVlECgKLMRsIs3KOMtcfTnksEr/dJ3qY6n3mHIiJ+WOG62OdIywmWUqQbStm/VylXpZpx9lHzMt+qdVR\
dSZ4IKZHGs1whmvYQwJRdbnUaoDdKTuJadax/VZZelKWaZrV2Y8k1DNabh/9lujpydBhp71O0WVr5hkPS+uGfezyhWznC6370JOhHL0RwUNIUI9KgliBh+EQY4/mPD1+A7MrUE0ko\
XuXZ59zXGLOEZeCPgXTjjdKWRZMAccU5T2U/VB0kr1mwbAahutebwRZ2vcqFomEtwsNoKX5gooWKpj5k9X1PCKrxzf0Jngg7MDTrNcYjnz5RjuCQce2uA41OmyzKGZbEnYQ7qCjnv\
2SfbZMX+QHkoa0s3KKLluIZ9yqjnowR/l87XwgQxtsdCIdtuhVv71hISR0p+GOu4BXZQfzxX6n+ZrPwhGyas2askAiunU84uG2jEIObGxEysYpyrBE9EwpiIMbC6onRA9ywOwo6V\
eAx2ygs9rNo5J3SuRAjLdBEv4vb2dkdyzRL3rbs+EbvrE7kUUpy5/kjVnk2JanniNWPafluPdpy11E2UI841ZNyR0ooJ3b97UzpdCMikdCCvGqeMTKk+aLfSfRAaPwTnzcCAAIkc\
WOY5G6f/8Sq4cA1FmefTDEHbvOkWPIBy6Wi0Wv1eMDa+XsZgTByhbUGR80Byk7WBxTrS2w7tEu7SJUlmYY8pGYl/Sw5ZXojPFCRPfL01EOW+frSOhEotOOkzrUIet8difjGz7qsU\
TO0oR6Pt7Ec3jcuo9dKe57Ws9I0WUL/YwLa+eSfwqxr533Z/SqNPYZaeK3R4iXDGvWYFYK4jGQb+Rryi4wHbaLYyTdejZFcLC4A02R1v+a2M7UzIpK4DjjjfCBe4WU+b8roe6XiB\
5iSjPjakIrC1bkrJ9mg/getzqrTut8nTEdXTNltK+xNOJxmWGJkeGEzjpp2GZQVp8uG/eFa4uY6PGdEY/PnADPZFKgZ1Z02Yp6xnVq541zN6bLN6YcDyd85fZY943eFNISr8rKl\
bk++CFWkEhtPcfH37vFk/G1ANYVvbaOr+zPZ/Sm4D1/corrX2E8Gy+U+GhvFx04e50UPxGhEh6VZTX4vS1zdOJ2PpMejzclbtgmzfCRL3dKaDoq/Mw6atoOiz5/Wq9Kt6MtElKm\
VyXKQ8q+69nnOGn9Ei/7ip7Gm8TfRGfMzXovzjQiyAWEwaySRUqDe41QfKIqba1Ij8qkGvzWJnk6HF9OFdewDcDwTyOnR/Rr2Jc7JSqaQgSGFjEMUuWytaIdFn3+xpBilyQkgDM\
J3hpfP0zwRlpCI3B0xYoVeQ4/y3TMSUnIdjZf9je0qDoQRUd59rlEEuJrHDE77zH1cPF70blKqrTy9j2iY4Wul+yJ4molVDqbPH6zSGcY9/fNApYxzoW/SFalbZ8WESquYRtb6C\
QNH/mSctnlWSrVcucXXbainnGd2nlU8HZZ7a4/QTCnEb2EhOvdVQedU6jgnfdj48VI4vgWChW8p1/v2I4ZMl9P8qYkxKagf/2s57oIXkXSx6cr+HixoOSJyk4vvZ0VeO4O86WX6\
1hZPZhyJOHrO02AqKuD6bLOF/cV6sqpMs06dsjR4Q7GdCb28UOODsoV7Fs2RZct9DMurJ1L/rFcXzu3xUdsAriYBG/0ppCWelVSrgwcBzrAUY94aNXskmM8269Oes876o/s0tt7\
zvsZ41GpKhi26iu7EEWPAfYEOG5Rgqej2Wt0e64R94U6zepgulMca2+3j7GDcAdSHNtMPYui6LKFOH9vi+5FiHbu84TYCeCmJZyDQbSk5TQRq3KHpxMcY7wqRbOd6KRqSSBi+Jw\
kkeKY6XOE57pYefq8ij/eUSPiSv0AKlqodKuH2J3xmE5ZPSNpv+cLs0fSJzMTSyjYqdsHPV/2wxFxk6WDGZQ1U/LbQbiDHpG01Pq66KpQAy66bCGecavEXXeO8kXb+UCG+9FriZ\
ZGHYeYLp+U5VVpQqx81bP93Tl+W1lBbIqrAlh48c6MIg35Y97kue5J0po8KSE+Gi8qswCtiKqemWEICC/vWbJ60qq4l+/SiBKfmaGjxDX2s/7dJ/4ppo2v+8ZaOD0xIsTXyTQ6NL\
tz8XVO0XoemFEQTDVquIg4jaLLFl2BOcsz7oo841ZgL0wYqp1H78ci6/ipwgRvpP5elT7jWUhigviHZZoBCebe59nnrCSB5vCm4P0z3iN+bq7RI4agfLasixcpVBqzFfAinaUeq\
G9hPHwlzrY6ruFIRxXX+Q9YX5azxb/4Xm+kcxxM+YK3BcVe1vFpAxcHIg24IyKAJHA9O0w5Z8UIs9BejyLLZq8JlOUZN9qRHSPUknaesXyNdp52DLg/ch4meCN1FyvwKJzp2Qez\
T7YsqNj4La7v2H63JAT0OmJTxsqq1c+TOK9mj/dh0XE6pTC+4PNfan1p9yqx0ms6DjuJ1yRZM5Zg2Bzr81YsMPv0Wi/vXtN5jkS+YOPW80m7cF1jiKbb+mrOkvskmrirUce0U3K\
T6jkUU4ZpEc8Djru2wGdcdNkaz6g74zNuLPzXijiV1dq5sTTtfEiyLZ44EtMO6U0hlREqSACnRHPWQ7HYHlbyfU3CdggJxHv8T+AiY2HAj6QQFMszCpVXiHu46kHR037rxiXiX\
16gfkLFzECYpwTKXlYn4hvP78v44u0zHYK9CnKPR3T0SfZpnIsi5c56/GCkc8malKvPdGx2PMhUcQ83DBohUHQgVNFlu8o6f0eKZ9yqetttap75iiqqndvtzj4vlqrglGRSCXJ\
OV0aSM6yf8zXHPhAUX1H294DFPUDc6Q+wCvT34jZ4hn2QA8aVe+Q6KTk4NScY4bjfCLG28qg0BMsC9VD7zEs8+lUt1tdx3i/DQetLs1Pi3e99kn8BvcY1Zoo/d4pL6NgdbZ5yD\
JkOsZFO3U6bbu8zZMrXyuDKosvWGGZqnLc3xtswIKuvudRqFpg23F1QOxdZPQFc4+VBSJ2FCrhc9FTdzRO2T1b2MWWnBCoqhMThnn2+IXoV4yzeFLCT57zX1/TxQlDe0rZCxfKu\
9Edf0g5VmldMiBTnCp/b5Ff33EDlaHT4oeo5J7BgGSrwGQxYwjOteFhQQDmS7tlIXDsPzDKrTdGbQipDw9OQY/gHgZrnKzvVsQ9WYD43STxk5J3i9ngiAdtFLkHmwLVSPcp+V40f\
8W3KDmm5AOZPi5BaYQ+pLWKCN9JGQBg86dgOb8uBga51tGc71iIadgmyBOCp2dLzIffXGj8jJKcbbfVFKVQIqRf2kBeDaEnlaCJTLUTKNz37IOfJOk0W8Q3iznGCNXcSZ+V4Zjdh\
WHqyY/sDUo/cKUn8RdlTFCqEkCTs2T7RWU+E1F2ogAvFna/j1aIX+msGpKhwxRz8RBwxiJ5wBcwkci0p8ljNH+8zkrAwI4UKIWsHjVwscUnwEDw70/o3vSmkHXlEdGCti+PEnUn\
WxTais926ONu10SNU8Bt2zfh5qubPBwG1S1p90fH8XRBSGTArrJGx187DEs0RkyabMiGl0ERAbQOsq3Owo8PfUdlbJd/smcNE5zRK4nbRM1ucdWvSI1F3Wp6hlh4VQqpJtxEuM2\
JECr0ppPJipQmQyuFHnn0+meO8U8QfjAuRNNpEvXw7TGyDxzuBQoWQtRdMo54n8VOv+802ihRSeZqMUwFniDvodHdlb8x4zg+LO9D1zz6BlKJeyz3l3qjuGlTZBq2+aPChn9HR0\
TkZ9+evmpBVNJZWoCAh9e3Nms+PhYUKb1L2NkeHebyyX6Y837rKDvXsg8y4y5qs1xJzjvUStm9c80e7XhlChR4VQgjJ9kXp6q1G26ieTQmVAGLldM92LFnx2pTneq+yrR3b\
kZp/foA6IVjWFcOxZc3bxeQyxBaFCiGEpAc5NpY7tnfUpB4THF/94LmmlU7zQgVDoHd46nBsyn7uKM8+EClPBrivECmPO7a/okZtJKn8kyhUCCGkurzg+WL+j5rUY0PRqxIn\
0fTslABxKvBO+bwqH1C2lWcfxLO41t9BducLAwkvxKfc79iO7Lrb1Lj971TGRSlUCCEkG39zbHu5uD0VVWEzj1CpSpr3a8S9ACxiT460/j3O1MuemXKM5xpXi84YG4q7PH1u\
b43b/u5lXJR5VAghJBsPO7ZtqmwLZX+seB2wcJ7LRTDU7AUCLTiLoTYkYJvn2KeRc2VbIxQxtPK86KD0h5Tt4TgWHpBzA9fnDs92xNacX8N2j3u7C4UKIYRUn3sc2/Alv2MNh\
Mqunu33VaisWCDwM5IciIrhtrgYlK1T1PPnomcYheS3or1uSUGnu5myPVCzdr+3uL1whcGhH0IIycbvPNv3rHj54X14s2M7ZsD8udmLBJr5AxATdEFB9+KcLPVJyT+U/cKxHR\
6fg2vW5jGkdkhZF6dQIYSQbPzBdOZJYKhhcoXLP1307I0kEGNRtSUaLlL2ROBzop4/LUCogCs92w+peBuJguGq/6JQIYSQeoBO/HbHdnRA+1a4/L4v45uCdTBjg3UxWLF3XuD7\
cKnoGJgiuEHcAcmbiD/ItyogROSzZRaAQoUQQrLzQ892xExMqGC5XyU6+VkS6LivDXWxlStXhuyrtg98LzC1ed20O69YsSLLuZ9Wdplnn09IPaYqf1zZDhQqhBBSL64TnYU0CSwq\
WcU4BHwZ+1YPvjeUSAm4RMr+ymYGvhfICXJcgfVBbhZX4jwEpp5X8X4YQ4Qnl10IChVCCMkOYlS+79kHL/hNKlTmtyg7wLNPsOGVjB4IFwj+PTHFfkjGhzWyLld2s7gT8zU4WjL\
EimSsE6Z4f9uzz1uVnVTRNo77fomyTgoVQgipJ/gadsU4QKScW5GydpovfF/ulKtDXAyeh4DeFAT/dnv2Qbp9eEgwHflDRpRhqOgKz3FTRAeKpiKHV+VU0bOAXHxB3MNxZXGuuf\
elQ6FCCCH5wOwf3+yO/ZR9qgJl/YayV3r2OU10OvmmCehNAW/3bL/FiI27I/+PVPYYMvqO5/g9C6zbo8q+lKIfxlpDb65Q24Z4ml2VwlCoEEJIcy903wJ+c5V9sMQyYr2cfT\
z7/F7Zt0JdMKA3BbiCaJGBFrNnljn2QRzKYsd2rMCcOvlpDq8KPBO+pHJYduGHUo0cPBBWn6vSj4xChRBC8oPEaKd69sFwy7dLEiuniT9gdNTs80IokRJQqODedTm2/8GILB\
fIv3KrY/tLRS/SWJQQw339qLIlnv02UvYjKS+xGhLRXSw6C3CloFAhhJDmxcCdnn2Q2RPu/VYNA62f4XqItflZqAsHnJLcECrjHNvTLp447Ng23nONEHXEwopHpNhvHdHDdBd\
mFU9NgmRuWE4gzUy1v4heQ4lChRBCagK+mD8sOneG730LUXOFx0vQLDuZTufAFPtiXZoTQ148sFCB68IVFLJpyvO8zLFtuecasXXM4TVCgrkvp9wXuUt+KXp9nSLBkBM8KEj5v\
3OK/THEhrif+ylUCCGkXiyS9C779yv7temMQiaFQ6eNYajblL0+xf5/M53Oc6EKEHjYpyFUXN6Q1xlzgdlXuzm2P5lCZIYSZJiKfEnKfbHCNeJWkLNn9wIEyseU/UZ0TMpLUj6\
Lg42oaenihBQqhBASBuRVOT7DFz7c+wiyxOyKKU1cF0m5vih67ZoTRA8f+PinEUx/CnkDAntTGtzl2IZcH2d6BN8Z4s6VgjiX5S2sKwTtZRn2f4fooTkIhEOVbZHzuhje2sEIE\
yysiZw5r05bXdFxNleU8cMaz3cLIYQE4wzzXp2bcn/MaPm66ORwSFKGRfIQ7/Kow9OBoMupyt5gOrE3mS/ktGAKMqZN3xK68gUJFdwTV6wNvA3Xmn3swNqtjYDb33P+6/MUCp4\
j1DfHekYYZjpItBfniAzH9Rp7xnhCMDSEoTvkv/mrea4YhkRczyTj9dhc9LT0nc2x24o7l05Se4En5Xtl/agoVAghJCynmS/00zMcs4npUGFIIoeARQx5IAPuEtO5IGnbFNP5b\
JqzbBjmQHbam0JXOnDKfJuFoofWpjn22cMINgypPWLuz87iH6LA8NeCZuqcc+FFKLojlT0sOm4lSzDvBkac7W6d61nTTiAqxpp6w9Zt8t4/bETVrWX+oChUCCGkGM/Ko8ZbkjUFO\
YYxtjIWkntEZ229u4gKFyRSxHgJEHsz37Mfhrx2zXjuc8SdY6XoOn9F9NDT+aK9ZHkYa8TLBoHvO7xUh5t2XCqMUSGEkGK4SnQQ58IKlGW+KcvdRV2gQKECsH7PDYHPiWGisyv\
wbDD09EbxrwvUKkZEr+y8VxVECoUKIYQUC7wYcNFj1eIlJVwf8QsYTjrIdECFUbBQwfAGglAfCnQ+rL+D6dvPNlvnQPVGUroPi445+nVJbXWFEbQ7KjurSj8iChVCCCkWDF18yX\
QA8yVQBlgPiEX5ornmFW1yHx9T9m5lDzZ5Hgz1YEmB31ewjggchncFcUR3tuiaWIYAgbLTjaB9oGo3hUKFEEJaw32mI0BCtq+JDuQs4hr/K3o2EdZrearN7iHEBYJm8w4DwVsBD\
9fNFa4jPBvfVbaLsreJXlRxcUFtBbE/yLnzAfGvR1QaDKYlhNSNiY5tmOUwpuLlR5zIYco+L3oROmQfxVTjvDN5kCX0FmXXmA74n23+/BE3gRWVMWX2WNGLCvrAEBgCVi8Q9wKGV\
QLDXTcaQ9tAjNEeRsAg8LYj4/kw3PVH0flYEBdzexP3YlLObRQqhJC1gj+bL+O44ADkHnm+JvWAR2W+McwMQo6L7ZR1m44ISco2NMIMdcXUU+TewJRlJGrD+jEDyu6tUecbCtwPL\
KCHxGm7G8GHe7eZEatoA8gtAg8MpmL3STkxQqFAXa40hn57S9GJ/rYRnTwQQmY901bgkcH0+BFzHKYYw3vygKRfG8nHgON3dk/oyo8pOACKEEIIISQ3jFEhhBBCCIUKIYQQQgiFC\
iGEEEIoVAghhBBCKFQIIYQQQqFCCCGEEEKhQgghhBBCoUIIIYQQChVCCCGEEAoVQgghhFCoEEIIIYRQqBBCCCGEUKgQQgghhEKFEEIIIYRChRBCCCEUKoQQQgghFCqEEEIIIRQqhB\
BCCKFQIYQQQggJwr8EGADoUi70jV4tUQAAAABJRU5ErkJggg==";

class ToolbarComponent extends React.Component {

    constructor(props) {
        super(props);
        this.initDict();

        document.addEventListener('touchstart', this.handleClick, false);
    }

    initDict = () => {
        let Dyn = this.props.Dyn;

        // menu value to parameter mapping, to add extra data to show how a menu item or the keystroke equivalent
        // should be handled.
        //  Replaces old plotElementDict, controlTypeDict, baseTypeDict, extraElementDict, extraTypeDict
        //  for addPlotClick(), old level 1: { m:'add', c:plotElement, t:controlType, extraType, extraElement }
        //  for addRemovePlotClick(), old level 2: { m:'addRemove', c:plotElement, t:controlType }
        //  for modifyTogglePlotClick(), old level 3: { m:'modifyToggle', c:plotElement, t:controlType, baseType }
        //  for addMultiplePlotClick() old level 4: { m:'addMultiple', c:plotElement, t:controlType }
        this.menuValueDict = {
            FreqHistogram: { m:'add', c:Dyn.FreqHistoElement, t:Dyn.EPlotControl.kControlsFreqHistogram,
                extraType: Dyn.EPlotControl.kControlsSectionCount, extraElement: Dyn.CountElement },
            PropHistogram: { m:'add', c:Dyn.RelProportionHistoElement, t:Dyn.EPlotControl.kControlsPropHistogram,
                extraType: Dyn.EPlotControl.kControlsSectionProportion, extraElement: Dyn.PercentageElement },
            PercHistogram: { m:'add', c:Dyn.RelPercentHistoElement, t:Dyn.EPlotControl.kControlsPercHistogram,
                extraType: Dyn.EPlotControl.kControlsSectionPercentage, extraElement: Dyn.PercentageElement },
            AnnotatePencilTool:   { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotatePencil },
            AnnotateRectTool:     { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotateRect },
            AnnotateCircleTool:   { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotateCircle },
            AnnotateArrowTool:    { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotateArrow },
            AnnotateStraightLineTool: { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotateStraightLine },
            AnnotateTextTool: { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotateText },
            AnnotateImageTool: { m:'annotate', c:Dyn.AnnotateLayerElement, t:Dyn.EPlotControl.kControlsAnnotateImage },
            CellCount: { m:'modifyToggle', c:Dyn.CountElement, t:Dyn.EPlotControl.kControlsCellCount,
                baseType: Dyn.EPlotControl.kControlsCount },
            CellPercent: { m:'modifyToggle', c:Dyn.PercentageElement, t:Dyn.EPlotControl.kControlsCellPercentage,
                baseType: Dyn.EPlotControl.kControlsPercentage },
            OverallPercent: { m:'modifyToggle', c:Dyn.PercentageElement, t:Dyn.EPlotControl.kControlsCellPercentage,
                baseType: Dyn.EPlotControl.kControlsPercentage }, // note: same as 'CellPercent' but dynamic menu naming is different.
            ColPercent: { m:'modifyToggle', c:Dyn.PercentageElement, t:Dyn.EPlotControl.kControlsColPercentage,
                baseType: Dyn.EPlotControl.kControlsPercentage },
            RowPercent: { m:'modifyToggle', c:Dyn.PercentageElement, t:Dyn.EPlotControl.kControlsRowPercentage,
                baseType: Dyn.EPlotControl.kControlsPercentage },
            SectionCount: {m: 'modifyToggle', c:Dyn.CountElement, t:Dyn.EPlotControl.kControlsSectionCount,
                baseType:Dyn.EPlotControl.kControlsCount},
            SectionSum: {m: 'modifyToggle', c:Dyn.CountElement, t:Dyn.EPlotControl.kControlsSectionSum,
                baseType:Dyn.EPlotControl.kControlsCount },
            SectionPercent: {  m:'modifyToggle', c:Dyn.PercentageElement, t:Dyn.EPlotControl.kControlsSectionPercentage,
                baseType: Dyn.EPlotControl.kControlsPercentage },
            SectionProportion: { m:'modifyToggle', c:Dyn.PercentageElement, t:Dyn.EPlotControl.kControlsSectionProportion,
                baseType: Dyn.EPlotControl.kControlsPercentage },
            Mean: { m:'addRemove',  c:Dyn.MeanElement, t:Dyn.EPlotControl.kControlsMean },
            MeanAvDev: { m:'addRemove',  c:Dyn.MeanAvDevElement, t:Dyn.EPlotControl.kControlsMeanAvDev },
            XRefLine: { m:'addMultiple', c:Dyn.XRefLineElement, t:Dyn.EPlotControl.kControlsXRefLine },
            Pie: { m: 'add', t: 'controlsPieChart',  c:Dyn.PieElement,
                extraType: Dyn.EPlotControl.kControlsSectionCount, extraElement: Dyn.CountElement },
            BarChartOfFreq: {m: 'add', c:Dyn.FreqBarElement, t: 'controlsBarChartOfFreq',
                extraType: [Dyn.EPlotControl.kControlsSectionSum,Dyn.EPlotControl.kControlsSectionCount], extraElement: Dyn.CountElement},
            BarChartOfValues: {m: 'add', c:Dyn.ValueBarElement, t: 'controlsBarChartOfValues' },
            BarChartOfSums: {m: 'add', c:Dyn.BarOfSumsElement, t: 'controlsBarChartOfSums',
                extraType: [Dyn.EPlotControl.kControlsSectionSum,Dyn.EPlotControl.kControlsSectionCount], extraElement: Dyn.CountElement },
            BarChartOfMeans: {m: 'add', c:Dyn.BarOfMeansElement, t: 'controlsBarChartOfMeans',
                extraType: Dyn.EPlotControl.kControlsSectionCount, extraElement: Dyn.CountElement},
            StretchedBar: {m: 'add', c:Dyn.StretchedBarElement, t: 'controlsStretchedBarChart',
                extraType: Dyn.EPlotControl.kControlsSectionCount, extraElement: Dyn.CountElement},
            LeastSqByAttribute: {m: 'modifyToggle', c:Dyn.LeastSquaresElement, t:Dyn.EPlotControl.kControlsLeastSquaresByAttribute,
                baseType:Dyn.EPlotControl.kControlsLeastSquares },
            LeastSqByCategory: {m: 'modifyToggle', c:Dyn.LeastSquaresElement, t:Dyn.EPlotControl.kControlsLeastSquaresByCategory,
                baseType:Dyn.EPlotControl.kControlsLeastSquares },
         }

    this.plotElementDict = {
        // OBSOLETE; use menuValueDict for any new values
        // Constructor of Dyn.PlotElement-derived class that this button modifies, Required for addPlotClick(), addRemovePlotClick(), or modifyTogglePlotClick()
        'Mixup': Dyn.MixupElement,
        'Dot': Dyn.DotPlotElement,
        'Line': Dyn.LineGraphSingleElement,
        'LineAndCategory': Dyn.LineAndCategoryElement,
        //'Pie': Dyn.PieElement,
        //'BarChartOfFreq': Dyn.FreqBarElement,
        // 'BarChartOfValues': Dyn.ValueBarElement,
        // 'BarChartOfSums': Dyn.BarOfSumsElement,
        // 'BarChartOfMeans': Dyn.BarOfMeansElement,
        // 'StretchedBar': Dyn.StretchedBarElement,
        //'FreqHistogram': Dyn.FreqHistoElement,
        'Box': Dyn.BoxOnlyPlotElement,
        'BoxAndOutlier': Dyn.BoxAndOutlierPlotElement,
        'BoxAndDot': Dyn.BoxAndDotPlotElement,
        'Count': Dyn.CountElement,
        //'CellCount': Dyn.CountElement,
        //'SectionCount': Dyn.CountElement,
        //'SectionSum': Dyn.CountElement,
        'Percent': Dyn.PercentageElement,
        // 'CellPercent': Dyn.PercentageElement,
        //'SectionPercent': Dyn.PercentageElement,
        // 'OverallPercent': Dyn.PercentageElement,
        // 'RowPercent': Dyn.PercentageElement,
        // 'ColPercent': Dyn.PercentageElement,
        //'Mean': Dyn.MeanElement,
        'Median': Dyn.MedianElement,
        'Mode': Dyn.ModeElement,
        'StDev': Dyn.StDeviationElement,
        'Variance': Dyn.VarianceElement,
        'IQR': Dyn.InterQuartRangeElement,
        'StdError': Dyn.StdErrorElement,
        'PopulationMean': Dyn.PopulationMeanElement,
        'PopulationMedian': Dyn.PopulationMedianElement,
        'PopulationStDev': Dyn.PopulationStDeviationElement,
        'PopulationVariance': Dyn.PopulationVarianceElement,
        'PopulationIQR': Dyn.PopulationInterQuartRangeElement,
        // 'LeastSquares': Dyn.LeastSquaresElement,
        // 'LeastSqByAttribute': Dyn.LeastSquaresElement,
        // 'LeastSqByCategory': Dyn.LeastSquaresElement,
        //'XRefLine': Dyn.XRefLineElement,
        'YRefLine': Dyn.YRefLineElement,
        'Y2RefLine': Dyn.Y2RefLineElement,
        'DiagRefLine': Dyn.DiagRefLineElement,
        'DiagRefLineY2': Dyn.DiagRefLineElementY2,
        'clearAllRefLines': null,
        'Dividers': Dyn.DividersElement,
        'ImagePNG': null,
        'ImageSVG': null,
        // 'Save': null,
        // 'Help': null,
        'Support': null,
        'SupportGuide': null,
        'Tutorials': null,
        //'swapAxes': null,
        // 'dataTypeX': null,
        // 'dataTypeY': null,
        'excludeSelected': null,
        'keepSelected': null,
        'resetAllFilter': null,
        // 'AnnotatePencilTool': Dyn.AnnotateLayerElement,
        // 'AnnotateRectTool': Dyn.AnnotateLayerElement,
        // 'AnnotateCircleTool': Dyn.AnnotateLayerElement,
        // 'AnnotateArrowTool': Dyn.AnnotateLayerElement,
        // 'AnnotateStraightLineTool': Dyn.AnnotateLayerElement,
        // 'AnnotateTextTool': Dyn.AnnotateLayerElement,
        'clearAllAnnotations': null,
        'Map': Dyn.MapElement,
        'undo': null,
        'redo': null,
        //'PlotFunction': Dyn.PlotFunctionElement,
        'GridLines': Dyn.GridLinesElement,
    };

    this.controlTypeDict = {
        // OBSOLETE; use menuValueDict for any new values
        // primaryType of Dyn.PlotElement-derived class that this button modifies, Required for addPlotClick(), addRemovePlotClick(), or modifyTogglePlotClick()
        'Mixup': Dyn.EPlotControl.kControlsMixup,
        'Dot': Dyn.EPlotControl.kControlsDotPlot,
        'Line': Dyn.EPlotControl.kControlsLineGraphSingle,
        'LineAndCategory': Dyn.EPlotControl.kControlsLineAndCategoryGraph,
        //'Pie': Dyn.EPlotControl.kControlsPieChart,
        // 'BarChartOfFreq': Dyn.EPlotControl.kControlsBarChartOfFreq,
        // 'BarChartOfValues': Dyn.EPlotControl.kControlsBarChartOfValues,
        // 'BarChartOfSums': Dyn.EPlotControl.kControlsBarChartOfSums,
        // 'BarChartOfMeans': Dyn.EPlotControl.kControlsBarChartOfMeans,
        // 'StretchedBar': Dyn.EPlotControl.kControlsStretchedBarChart,
        //'FreqHistogram': Dyn.EPlotControl.kControlsFreqHistogram,
        'Box': Dyn.EPlotControl.kControlsBoxOnlyPlot,
        'BoxAndOutlier': Dyn.EPlotControl.kControlsBoxAndOutlierPlot,
        'BoxAndDot': Dyn.EPlotControl.kControlsBoxAndDotPlot,
        'Count': Dyn.EPlotControl.kControlsCount,
        'Percent': Dyn.EPlotControl.kControlsPercentage,
        //'CellCount': Dyn.EPlotControl.kControlsCellCount,
        //'SectionCount': Dyn.EPlotControl.kControlsSectionCount,
        //'SectionSum': Dyn.EPlotControl.kControlsSectionSum,
        // 'CellPercent': Dyn.EPlotControl.kControlsCellPercentage,
        //'SectionPercent': Dyn.EPlotControl.kControlsSectionPercentage,
        // 'OverallPercent': Dyn.EPlotControl.kControlsCellPercentage, // note: same as 'CellPercent' but dynamic menu naming is different.
        // 'ColPercent': Dyn.EPlotControl.kControlsColPercentage,
        // 'RowPercent': Dyn.EPlotControl.kControlsRowPercentage,
        //'Mean': Dyn.EPlotControl.kControlsMean,
        'Median': Dyn.EPlotControl.kControlsMedian,
        'Mode': Dyn.EPlotControl.kControlsMode,
        'StDev': Dyn.EPlotControl.kControlsStDeviation,
        'Variance': Dyn.EPlotControl.kControlsVariance,
        'IQR': Dyn.EPlotControl.kControlsInterQuartRange,
        'StdError': Dyn.EPlotControl.kControlsStdError,
        'PopulationMean': Dyn.EPlotControl.kControlsPopulationMean,
        'PopulationMedian': Dyn.EPlotControl.kControlsPopulationMedian,
        'PopulationStDev': Dyn.EPlotControl.kControlsPopulationStDeviation,
        'PopulationVariance': Dyn.EPlotControl.kControlsPopulationVariance,
        'PopulationIQR': Dyn.EPlotControl.kControlsPopulationInterQuartRange,
        // 'LeastSquares': Dyn.EPlotControl.kControlsLeastSquares,
        // 'LeastSqByAttribute': Dyn.EPlotControl.kControlsLeastSquaresByAttribute,
        // 'LeastSqByCategory': Dyn.EPlotControl.kControlsLeastSquaresByCategory,
        //'XRefLine': Dyn.EPlotControl.kControlsXRefLine,
        'YRefLine': Dyn.EPlotControl.kControlsYRefLine,
        'Y2RefLine': Dyn.EPlotControl.kControlsY2RefLine,
        'DiagRefLine': Dyn.EPlotControl.kControlsDiagRefLine,
        'DiagRefLineY2': Dyn.EPlotControl.kControlsDiagRefLineY2,
        'clearAllRefLines': Dyn.EPlotControl.kControlsNothing,
        'Dividers': Dyn.EPlotControl.kControlsDividers,
        'Image': Dyn.EPlotControl.kControlsNothing,
        // 'Save': Dyn.EPlotControl.kControlsNothing,
        // 'Help': Dyn.EPlotControl.kControlsNothing,
        'Support': Dyn.EPlotControl.kControlsNothing,
        'SupportGuide': Dyn.EPlotControl.kControlsNothing,
        'Tutorials': Dyn.EPlotControl.kControlsNothing,
        // 'swapAxes': Dyn.EPlotControl.kControlsNothing,
        // 'dataTypeX': Dyn.EPlotControl.kControlsNothing,
        // 'dataTypeY': Dyn.EPlotControl.kControlsNothing,
        'excludeSelected': Dyn.EPlotControl.kControlsNothing,
        'keepSelected': Dyn.EPlotControl.kControlsNothing,
        'resetAllFilter': Dyn.EPlotControl.kControlsNothing,
        // 'AnnotatePencilTool': Dyn.EPlotControl.kControlsAnnotatePencil, // Note: Dyn.AnnotateLayerElement holds 0+ lines, so element might be in plot with no lines visible
        // 'AnnotateRectTool': Dyn.EPlotControl.kControlsAnnotateRect,
        // 'AnnotateCircleTool': Dyn.EPlotControl.kControlsAnnotateCircle,
        // 'AnnotateArrowTool': Dyn.EPlotControl.kControlsAnnotateArrow,
        // 'AnnotateStraightLine': Dyn.EPlotControl.kControlsAnnotateStraightLine,
        // 'AnnotateTextTool': Dyn.EPlotControl.kControlsAnnotateText,
        'clearAllAnnotations': Dyn.EPlotControl.kControlsNothing,
        'Map': Dyn.EPlotControl.kControlsMap,
        'undo': Dyn.EPlotControl.kControlsNothing,
        'redo': Dyn.EPlotControl.kControlsNothing,
        //'PlotFunction': Dyn.EPlotControl.kControlsPlotFunction,
        'GridLines': Dyn.EPlotControl.kControlsGridLines,
    };

    // this.baseTypeDict = {
        // OBSOLETE; use menuValueDict for any new values; TODO: remove this parameter entirely
        // Optional primaryType of Dyn.PlotElement-derived class that this button modifies, Required for modifyTogglePlotClick() (data-level=3)
        //'CellCount': Dyn.EPlotControl.kControlsCount,
        //'SectionCount': Dyn.EPlotControl.kControlsCount,
        //'SectionSum': Dyn.EPlotControl.kControlsCount,
        // 'CellPercent': Dyn.EPlotControl.kControlsPercentage,
        //'SectionPercent': Dyn.EPlotControl.kControlsPercentage,
        // 'OverallPercent': Dyn.EPlotControl.kControlsPercentage,
        // 'ColPercent': Dyn.EPlotControl.kControlsPercentage,
        // 'RowPercent': Dyn.EPlotControl.kControlsPercentage,
        // 'LeastSqByAttribute': Dyn.EPlotControl.kControlsLeastSquares,
        // 'LeastSqByCategory': Dyn.EPlotControl.kControlsLeastSquares
    // };

    // this.extraTypeDict = {
        // OBSOLETE; use menuValueDict for any new values; TODO: remove this parameter entirely
        // Optional 2nd type of Dyn.PlotElement-derived class that this button adds, addPlotClick() (data-level=1)
        //'Pie': Dyn.EPlotControl.kControlsSectionCount,
        // 'BarChartOfFreq': [Dyn.EPlotControl.kControlsSectionSum,Dyn.EPlotControl.kControlsSectionCount],
        // //'BarChartOfValues': Dyn.EPlotControl.kControlsSectionSum,
        // 'BarChartOfSums': [Dyn.EPlotControl.kControlsSectionSum,Dyn.EPlotControl.kControlsSectionCount],
        // 'BarChartOfMeans': Dyn.EPlotControl.kControlsSectionCount,
        // 'StretchedBar': Dyn.EPlotControl.kControlsSectionPercentage,
        //'FreqHistogram': Dyn.EPlotControl.kControlsSectionCount,
        //'PlotFunction': Dyn.EPlotControl.kControlsGridLines,
    // };

    // this.extraElementDict = {
        // OBSOLETE; use menuValueDict for any new values; TODO: remove this parameter entirely
        // Optional constructor 2nd Dyn.PlotElement-derived class that this button adds, to pair with extraTypeDict entries.
        //'Pie': Dyn.CountElement,
        // 'BarChartOfFreq': Dyn.CountElement,
        // //'BarChartOfValues': Dyn.CountElement,
        // 'BarChartOfSums': Dyn.CountElement,
        // 'BarChartOfMeans': Dyn.CountElement,
        // 'StretchedBar': Dyn.PercentageElement,
        //'FreqHistogram': Dyn.CountElement
    // }
    }

    state = {
        plotView: undefined,
        columns: [],
        casesExcluded: [],
        menus: ToolbarMenus.DEFAULT,
        openedMenus: [],
        fitableChildrenCount: -1,
        menuSpacerClassName: 'tde-space0'
    }

    submenus = {};

    static getDerivedStateFromProps(props, state) {
        if(props.config && props.config.toolbarItems && props.config.toolbarItems.length) {
            state.menus = filterMenus(props.config.toolbarItems, JSON.parse(JSON.stringify(ToolbarMenus.DEFAULT)));
        } else {
            state.menus = props.mode? JSON.parse(JSON.stringify(ToolbarMenus[props.mode.toUpperCase()])) : JSON.parse(JSON.stringify(ToolbarMenus.DEFAULT));
        }
        // Remove the menu "Reload the plot" when there are no saved plot states and view only mode is enabled
        let showSoftResetButton = props.Dyn.plotView?.hasSavedPlotState() && !props.Dyn.preferences.isViewOnly();
        if(!showSoftResetButton) {
            const undoredoGroup = state.menus.findIndex(menu => menu.groupId === 'undoredo');
            if(undoredoGroup >=0) {
                const undoRedoMenu = state.menus[undoredoGroup];
                const softResetIndex = undoRedoMenu.children.findIndex(menu => menu.value === 'reloadPlot');
                if(softResetIndex >= 0) {
                    undoRedoMenu.children.splice(softResetIndex, 1);
                }
            }
        }
        // Add sampling menus
        if(props.sampleMode.isSampleMode) {
            let statsIndex = state.menus.findIndex(menu => menu.groupId === 'stats'),
                whichChildMenu = samplingStatesMenuChildren;
            switch( props.sampleMode.selectedView ){
                case 'viewDistribution':
                    whichChildMenu = samplingDistributionMenuChildren;
                    break;
                case 'viewPopulation':
                    whichChildMenu = samplingPopulationMenuChildren;
                    break;
            }
            if(statsIndex >=0) {
                // TODO: Apply filtered menus for sampling menus
                state.menus[statsIndex].children = whichChildMenu;
            }
        }
        // To remove Save menu
        // if(!props.allowPlotStateSave || !props.onPlotSave) {
        //    const saveIndex = state.menus.findIndex(menu => menu.value === 'Save');
        //    if(saveIndex >= 0) {
        //        state.menus.splice(saveIndex, 1);
        //    }
        // }
        /*
        let _menus = ToolbarComponent.resetToolbarMenuItems(state.menus, props.language, state.availableWidth, props.mode);
        state.menus = _menus.menus;
        state.menuSpacerClassName = _menus.spacerClassName;
        */
        state.menus = ToolbarComponent.setMoreIfRequired(state.menus, state.fitableChildrenCount, props.mode);
        return state;
    }

    /**
     * Group overflowing menu's under more menu
     * @param {*} menus
     * @param {number} fitableChildrenCount
     */
    static setMoreIfRequired(menus, fitableChildrenCount, mode) {
        fitableChildrenCount = fitableChildrenCount || -1;
        if(fitableChildrenCount > 0 && fitableChildrenCount < menus.length) {
            let noOfExtraMenus = menus.length - fitableChildrenCount;
            if(noOfExtraMenus > 0) {
                // Increament one for the more menu
                noOfExtraMenus++;
                const extraMenus = menus.splice(-noOfExtraMenus, noOfExtraMenus);
                if (requireJrMode(mode)) {
                    menus.push({
                        iconClass: "tde-i tde-i-chevron-down2",
                        groupId: "More",
                        children: extraMenus,
                        label: "More",
                    });
                } else {
                    menus.push({
                        iconClass: "tde-i tde-i-more",
                        groupId: "More",
                        children: extraMenus,
                    });
                }
            }
        }
        return menus;
    }

    /* componentWillReceiveProps = (nextProps, prevProps) => {
        if(nextProps.mode !== prevProps.mode) {
            this.setState({
                menus: ToolbarMenus[nextProps.mode && nextProps.mode.toUpperCase()] || this.DEFAULT_MENUS
            })
        }
    } */

    componentDidMount = () => {
        let Dyn = this.props.Dyn;
        let mediator = this.props.Dyn.mediator;
        // To group or regroup toolbar menus based on available width.
        // (Call it on window resize and plot container resize)
        // window.addEventListener("resize", this.notifyWidthChange);
        this.subscriptions = [];
        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:containerResized", this.notifyWidthChange);
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:modelFunctionVisibility", (data) => {
            this.setState({
                highlightModelFunction: data
            });
        });

        // The following three event listeners are used to sync plotview and the respective menu items
        // Example: "Pie" will be active when pie chart is plotted in the plotview
        function updateMenuActivationState( toolbar ) {
            // toolbar.setState({ plotView: toolbar.state.plotView });
            toolbar.forceUpdate();
        }

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:modelUpdated", ( plotData ) => {
            this.setState({
                plotView: plotData.plotView
            });
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:removedOneAdornment", ( plotData ) => {
            updateMenuActivationState( this );
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "undoManager:updated", ( undoManagerData ) => {
            updateMenuActivationState( this );
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "pref:newColorScheme", ( data ) => {
            updateMenuActivationState( this );
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "pref:animationOnOff", ( data ) => {
            updateMenuActivationState( this );
        });

        // on Reset Filter and remove all filter menu items, after filter is applied
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:setCasesFiltered", (args) => {
            let filter = Dyn.dataSet.caseFilter,
                totalCasesFiltered = filter.getNumCasesFiltered(),
                //totalCasesInDataSet = Dyn.dataSet.getNumCasesPreFilter(),
                excludedCases = filter.getNumCasesExcludedBySelection();
                //sampledCases = filter.getNumCasesInSample(),
                //notSampledCases = Math.max( 0, totalCasesInDataSet - sampledCases );

            let casesExcluded = [];

            if( totalCasesFiltered > 0 ) {
                if (excludedCases > 0) {
                    casesExcluded.push({
                        label: 'Reset Filter of Selected Cases' + ' (' + excludedCases + ')',
                        value: 'excludedCases'
                    });
                }
                //if (sampledCases > 0) {
                //    casesExcluded.push({
                //        label: 'Reset Filter by Sample' + ' (' + notSampledCases + ')',
                //        value: 'sampledCases'
                //    });
                //}
                // exclusion from the filter panel in case card
                for ( var i = 0; i < Dyn.dataSet.attribs.length; i++ ) {
                    var casesFilteredByAttribute = filter.getNumCasesExcludedByAttribute(Dyn.dataSet.attribs[i].id);
                    if(casesFilteredByAttribute > 0) {
                        var attribute = Dyn.dataSet.attribs[i];
                        casesExcluded.push({
                            label: "Reset Filter By " + attribute.name + " (" + casesFilteredByAttribute + ")",
                            value: 'filteredAttributeCases',
                            id: attribute.id
                        });
                    }
                }
            }
            this.setState({
                casesExcluded: casesExcluded
            });
        });

        // on adding or removing a Y2 axis in the plot, show or hide the Y2 axis menu items
        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:addRemoveY2Axis", (args) => {
            this.setState({
                showY2AxisMenuItems: args.hasY2Axis
            });
        });

        // on Order by attribute, apply the style to Order By toolbar item
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:setOrderByAttribute", (args) => {
            this.setState({
                orderedAttributeId: args.id
            });
        });

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:destroy", ( data ) => {
            this.setState({ plotView:null });
        });

        /*
        // Set available width
        this.state.availableWidth = this.toolbar.getWidth();
        */

        // Give some time to load tuva-icons fonts
        setTimeout(()=> {
            if(this.toolbar) {
                this.setSpacerClassBasedOnAvailableWidthAndNoOfMenu();
            }
        }, 2500);
    }

    /**
     * To force update the toolbar by recalculate the overflowing menu's
     */
    forceRefreshToolbar() {
        // Set fitableChildrenCount to -1 to render all children to recalculate the available space for children
        this.setState({
            fitableChildrenCount: -1,
            menuSpacerClassName: 'tde-space0'
        });
    }

    componentDidUpdate () {
        // Get the actual fitableChildrenCount if fitableChildrenCount = -1
        if(this.state.fitableChildrenCount === -1) {
            this.setSpacerClassBasedOnAvailableWidthAndNoOfMenu();
        }
    }

    /**
     * Function to take care of toolbar menu space and grouping
     */
    setSpacerClassBasedOnAvailableWidthAndNoOfMenu() {
        let _state = {};
        let noOfExtraMenus = 0;
        const totalNoOfMenus = this.state.menus.length;
        let fitableChildrenCount = this.toolbar.getfitableChildrenCount(this.props.mode);

        if(fitableChildrenCount > 0 && fitableChildrenCount < totalNoOfMenus) {
            noOfExtraMenus = totalNoOfMenus - fitableChildrenCount;
        }
        if(!requireJrMode(this.props.mode) && noOfExtraMenus > 0 && this.state.menuSpacerClassName !== 'tde-space8') {
            let _index = parseInt(this.state.menuSpacerClassName.slice(-1)) + 1;
            _state.menuSpacerClassName = 'tde-space' + _index;
            _state.fitableChildrenCount = -1;
        } else {
            _state.fitableChildrenCount = fitableChildrenCount;
            // Publish classname to parent component
            this.props.setFinalClass(this.state.menuSpacerClassName);
        }
        this.setState(_state);
    }

    notifyWidthChange = () => {
        this.toolbar && this.forceRefreshToolbar();
        /*
        if ( this.toolbar ) {
            this.state.availableWidth = this.toolbar.getWidth();
            this.forceUpdate();
        }
        */
    }

    // To get localized label values
    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        if(Dyn.dataSet && str) {
            return Dyn.loc( str );
        } else {
            return str;
        }
    }

    // To save the active plot area as PNG
    savePlotAsPNGImage = () => {
        let Dyn = this.props.Dyn;
        this.convertPlotArea2Canvas((canvas) => {
            // adding footer with logo
            var footerHeight = 60,
            canvasImage = document.createElement("canvas");
            canvasImage.setAttribute('width',canvas.width);
            canvasImage.setAttribute('height',canvas.height + footerHeight);

            var context = canvasImage.getContext('2d');
            context.drawImage(canvas,0,0,canvas.width, canvas.height);

            var base_image = new Image();
            base_image.src = TuvaLogo;
            base_image.onload = () => {
                var startX = 0,
                startY = canvasImage.height - footerHeight,
                barWidth = canvasImage.width,
                fontColor = '#808080',
                fontSize = '10pt "Montserrat", sans-serif';

                // To fill the footer background
                context.beginPath();
                context.rect(startX, startY, barWidth, footerHeight);

                context.fillStyle = '#fff';
                context.strokeStyle = "#ccc";
                context.lineWidth = 1;

                context.fill();
                context.stroke();
                context.closePath();

                // To draw tuva logo
                var logoXPos = barWidth - 210,
                    logoYPos = startY + 5;
                context.drawImage(base_image, logoXPos, logoYPos, 200, 50);

                // add company name
                /*
                context.beginPath();
                context.fillStyle = fontColor;
                context.strokeStyle = fontColor;
                context.font = fontSize;
                context.fillText(Dyn.dataSet.dataUrl, startX+110, startY+25);
                context.closePath();
                */

                // draw rectangle around it
                /*
                var textStats = context.measureText(Dyn.dataSet.dataUrl);
                context.beginPath();
                context.rect(startX+105, startY+7, textStats.width+10, 25);
                context.strokeStyle = fontColor;
                context.stroke();
                context.closePath();
                */

                // add source on right side of the footer
                if ( Dyn.dataSet.dataSource && Dyn.dataSet.dataSource !== '-' ) {
                    var sourceText = "SOURCE: "+ Dyn.dataSet.dataSource,
                    measureSourceTextSize = context.measureText( sourceText ),
                    startSourceText = startX+20;
                    context.font = fontSize;
                    context.fillStyle = fontColor;
                    context.strokeStyle = fontColor;
                    context.fillText( sourceText, startSourceText , startY+35 );
                    context.closePath();
                }

                // To increase the DPI
                this.setCanvasDPI(canvasImage, 150);

                // To make the canvas download
                var link = document.createElement("a"),
                chartTitle = Dyn.plotView.topMargin.getTitle() + "_tuvalabs.png";
                link.download = chartTitle;
                link.type = "hidden";
                link.href = canvasImage.toDataURL("image/png");
                document.body.appendChild(link);	// required for firefox
                link.click();
                document.body.removeChild(link);
            };
        });
        _gaq.push(['_trackEvent', 'Plot Function', 'Click', "ImagePNG"]);
    }

    // Convert active plot area with map to canvas
    convertPlotArea2Canvas = (cb) => {
        let Dyn = this.props.Dyn;
        // make the plot image ready
        Dyn.plotView.makePlotImageReady( true );
        this.props.plotContainer.style.setProperty("background-color", "#fff");

        // Note: Adding dummy promise to handle the safari browser issue
        const dummyPromise = new Promise((resolve, reject) => {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if(isSafari) {
                // Call toCanvas once to make the Safari ready for the actual call in th next block
                toCanvas(this.props.plotContainer, {quality: 1, scale: 2}).then((canvas) => {
                    resolve();
                }).catch((err) => {
                    resolve();
                });
            } else {
                resolve();
            }
        });

        dummyPromise.then((canvas) => {
            // Making actual call to capture the screenshot of the plot
            toCanvas(this.props.plotContainer, {quality: 1, scale: 2}).then((canvas) => {
                // revert plot from image ready state
                Dyn.plotView.makePlotImageReady( false );
                this.props.plotContainer.style.removeProperty("background-color");
                cb(canvas);
            }).catch((err) => {
                console.error("Error while capturing screenshot of current plot.", err);
            });
        });
    }

    // To set canvas DPI
    setCanvasDPI = (canvas, dpi) => {
        // Set up CSS size.
        canvas.style.width = canvas.style.width || canvas.width + 'px';
        canvas.style.height = canvas.style.height || canvas.height + 'px';

        // Get size information.
        var scaleFactor = dpi / 96;
        var width = parseFloat(canvas.style.width);
        var height = parseFloat(canvas.style.height);

        // Backup the canvas contents.
        var oldScale = canvas.width / width;
        var backupScale = scaleFactor / oldScale;
        var backup = canvas.cloneNode(false);
        backup.getContext('2d').drawImage(canvas, 0, 0);

        // Resize the canvas.
        var ctx = canvas.getContext('2d');
        canvas.width = Math.ceil(width * scaleFactor);
        canvas.height = Math.ceil(height * scaleFactor);

        // Redraw the canvas image and scale future draws.
        ctx.setTransform(backupScale, 0, 0, backupScale, 0, 0);
        ctx.drawImage(backup, 0, 0);
        ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
    }

    openToolSupport = () => {
        var win = window.open('https://support.tuvalabs.com/', '_blank');
        win.focus();
    }

    openToolUserGuide = () => {
        var win = window.open('https://docs.google.com/document/d/1pwg2WK2nlD1aVZIweIK3i_P4AVh-BGMqj05axJ9mPqc/edit?usp=sharing', '_blank');
        win.focus();
    }

    openToolTutorials = () => {
        _gaq.push(['_trackEvent', 'Tutorial', 'Click', 'Data Exploration']);
        var win = window.open('https://tuvalabs.com/tutorials/', '_blank');
        win.focus();
    }

    // Handler for exclude selected cases
    excludeSelected = () => {
        let Dyn = this.props.Dyn;
        Dyn.dataSet.caseFilter.excludeSelected();
    }

    // Handler for keep selected cases
    keepSelected = () => {
        let Dyn = this.props.Dyn;
        Dyn.dataSet.caseFilter.keepOnlySelected();
    }

    // Handler for clear all reference lines
    clearAllRefLines = (menu) => {
        let Dyn = this.props.Dyn;
        if(this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
            return;
        }
        var controlsRefLines = Dyn.EPlotControl.kControlsRefLine;
        if( Dyn.plotView.plotShaper.hasElement( controlsRefLines ) ){
            Dyn.plotView.removePlot( controlsRefLines );
            _gaq.push(['_trackEvent', 'Plot Function', 'Click', menu.value]);
        }
    }

    // Handler for reset all filters
    resetAllFilter = (menu) => {
        let Dyn = this.props.Dyn;
        Dyn.dataSet.caseFilter.resetAll();
        _gaq.push(['_trackEvent', 'Plot Function', 'Click', menu.value]);
    }

    // Handler for annotation child menus clicks
    startStopAnnotationClick = ( menu, toolType ) => {
        let Dyn = this.props.Dyn,
            plotElementConstructor = this.menuItemToPlotAction( menu ).c;
        Dyn.plotView.addPlot( new plotElementConstructor( Dyn, toolType ) /*e.g. new Dyn.AnnotateLayerElement()*/ );
        _gaq.push(['_trackEvent', 'Plot Sketch', 'Click', menu.value]);
    }

    // handle a click on the clear all annotations button.
    clearAllAnnotations = (menu) => {
        let Dyn = this.props.Dyn;
        if(this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
            return;
        }
        var controlsAnnotations = Dyn.EPlotControl.kControlsAnnotations;
        if( Dyn.plotView.plotShaper.hasElement( controlsAnnotations ) ){
            Dyn.plotView.removePlot( controlsAnnotations, false, Dyn.loc("Clear All Annotations"));
            Dyn.plotView.stopViewMode("draw-tool");
            _gaq.push(['_trackEvent', 'Plot Function', 'Click', menu.value]);
        }
    }

    // handle a click on the Sketch button to start then stop sketch mode for freehand lines.
    undoRedoClick = ( menu ) => {
        let Dyn = this.props.Dyn;
        switch( menu.value ) {
            case 'undo':
                Dyn.undoManager.undo();
                break;
            case 'redo':
                Dyn.undoManager.redo();
                break;
            case 'reloadPlot':
                Dyn.plotView.restoreSavedPlotState();
                break;
        }
        _gaq.push(['_trackEvent', 'Plot UndoRedo', 'Click', menu.value]);
    }

    // check if current plot has annotation item selected,
    // if selected, copy the reference to clipboard
    copyAnnotation = () => {
        // find current selected item, if its an annotation object
        const Dyn = this.props.Dyn,
            annotateLayerElement = Dyn.plotView?.plotShaper.findElement(
                Dyn.EPlotControl.kControlsAnnotations);
        if(annotateLayerElement?.selectedObjectIndex >= 0) {
            Dyn.copiedAnnotationElement = annotateLayerElement.objects[annotateLayerElement.selectedObjectIndex].save();
            // Clean the clipboard content
            window.navigator.clipboard.writeText("").then(() => {
                /* Cleaned clipboard content */
            }, () => {
                /* Failed to clean content from clipboard */
            });
            Dyn.plotView?.setBackgroundFocus();
        }
    }

    // if annotation layer, paste currently selected one to the current plot
    // TODO: also allow to paste multiple annotations
    pasteAnnotation = () => {
        const Dyn = this.props.Dyn,
            annotateLayerElement = Dyn.plotView?.plotShaper.findElement(Dyn.EPlotControl.kControlsAnnotations);
        if (annotateLayerElement && Dyn.copiedAnnotationElement ) {
            Dyn.AnnotateLayerElement.offsetSavedDataForPaste( Dyn.copiedAnnotationElement ); // move/offset the pasted object a bit so it is visible.
            // Create new element from the saved data, AnnotateLayerElement will handle offset of object
            const ele = new Dyn.AnnotateLayerElement( Dyn, Dyn.copiedAnnotationElement.type, Dyn.copiedAnnotationElement );
            Dyn.plotView.addPlot( ele ); // Add to plot view
            Dyn.plotView.setBackgroundFocus();
        }
    }

    // handle a click on the Reset button (originally called "Mixup")
	mixupClick = ( menu ) => {
        let Dyn = this.props.Dyn,
            mediator = this.props.Dyn.mediator,
            plotView = Dyn.plotView;
        mediator.publish( "card:reinstateCaseCard", {} );
        plotView?.mixUp();
		// track the plot creation event
		_gaq.push(['_trackEvent', 'Plot Created', 'Click', menu.value]);
	}

    /**
     * Get the controlType (Dyn.EPlotControl) associated with this menu item, if any, to determine
     * if the assocated plot element (e.g. Histogram, Means, Pencel, etc), is in the plot.
     * see also menuItemToPlotAction()
     * @param menuItem
     * @return {string|undefined} - Dyn.EPlotControl value, if any.
     */
    menuItemToPlotControlType = ( menuItem ) => {
        let plotAction = this.menuValueDict[menuItem.value]; // dictionary for newer menu items
        return plotAction ? plotAction.t :
            this.controlTypeDict[menuItem.value]; // dictionary for older menu items (TODO: move to new method)
    }

    // Get the plot action parameters to handle this menu item, if any, using one of our 4 standard handlers:
    //  (1) addPlotClick(), (2) addRemovePlotClick(), (3) modifyTogglePlotClick(), (4) addMultiplePlotClick().
	// check our menuValueDict or old controlTypeDict|plotElementDict parameters to handle the menu item.
    menuItemToPlotAction = ( menuItem ) => {
        let plotAction = this.menuValueDict[menuItem.value]; // dictionary for newer menu items
        if( ! plotAction ) {
            // convert old menuItem.level values to new actions (TODO: move values to new this.menuValueDict to consolidate)
            switch( menuItem.level ){
                case 1: // convert old menuItem level 1 to 'add' action to call addPlotClick()
                    plotAction = {  m:'add', c:this.plotElementDict[menuItem.value], t:this.controlTypeDict[menuItem.value] };
                    // plotAction.extraType = this.extraTypeDict[menuItem.value];
                    // plotAction.extraElement = this.extraElementDict[menuItem.value] ;
                    console.log("ToolbarComponent old level", menuItem.level, menuItem.value, plotAction );
                    break;
                case 2: // convert old menuItem level 2 to 'add' action to call addRemovePlotClick()
                    plotAction = {  m:'addRemove', c:this.plotElementDict[menuItem.value], t:this.controlTypeDict[menuItem.value] };
                    console.log("ToolbarComponent old level", menuItem.level, menuItem.value, "c: "+plotAction.c.name, JSON.stringify(plotAction));
                    break;
                case 3: // convert old menuItem level 3 to 'add' action to call modifyTogglePlotClick()
                    plotAction = {  m:'modifyToggle', c:this.plotElementDict[menuItem.value], t: this.controlTypeDict[menuItem.value] };
                    // plotAction.baseType = this.baseTypeDict[menuItem.value];
                    console.log("ToolbarComponent old level", menuItem.level, menuItem.value, "c: "+plotAction.c.name, JSON.stringify(plotAction));
                    break;
                case 4:  // convert old menuItem level 4 to 'add' action to call addMultiplePlotClick()
                    plotAction = {  m:'addMultiple', c:this.plotElementDict[menuItem.value], t:this.controlTypeDict[menuItem.value] };
                    console.log("ToolbarComponent old level", menuItem.level, menuItem.value, "c: "+plotAction.c.name, JSON.stringify(plotAction));
                    break;
                default:
                    plotAction = {}; // menuItem item is not in menuValueDict and no .level; ignore
            }
        }
        return plotAction;
    }

    // handle a click on a button that adds a Dyn.PlotElement to the plot.
    // TODO: simplify this structure by having the plotElementConstructor, extraType, extraElement, removeType all
    //          all key of the controlType; e.g. find the constructor for the controlType, construct it, query object
    //          for any extra elements to be added and removed from plot. This will further localize the code to
    //          the actual plot element controller (e.g. kControlsFrequencyHistogram decides which count/percent to turn on and off)
	addPlotClick = ( menu, method, plotElementConstructor, controlType,  extraType, extraElement /*, removeTypes*/ ) => {
        let Dyn = this.props.Dyn;
        Dyn.assert( method==='add' ); // old menu.level===1
        Dyn.assert( typeof plotElementConstructor==='function');
        let needsPlot =( ! Dyn.plotView.plotShaper.hasElement( controlType )),
            needsExtraPlotElement = false;

        if( extraType && typeof extraType === 'string' ) {
            needsExtraPlotElement = !Dyn.plotView.plotShaper.hasElement(extraType);
        } else if( extraType && Array.isArray( extraType )) {
            needsExtraPlotElement = extraType.find( e => !Dyn.plotView.plotShaper.hasElement(extraType));
        }

        if( needsPlot || needsExtraPlotElement ) {
            if( needsExtraPlotElement ) {
                Dyn.plotView.addPlot( new plotElementConstructor( Dyn ), new extraElement( Dyn, extraType ) );
            }  else if(menu.value === "Map") {
                Dyn.plotView.addPlot( new plotElementConstructor( Dyn, {plotContainer: this.props.plotContainer}));
            } else {
                Dyn.plotView.addPlot( new plotElementConstructor( Dyn ) );
            }
            // track the plot creation event
            _gaq.push( ['_trackEvent', 'Plot Created', 'Click', menu.value] );
        }
        // else ignore click
    }

    // handle a click on a button that adds or removes a Dyn.PlotElement to the plot.
	addRemovePlotClick = ( menu, method, plotElementConstructor, controlType ) => {
        let Dyn = this.props.Dyn;
        Dyn.assert( method==='addRemove' ); // old menu.level===2
        Dyn.assert( typeof plotElementConstructor==='function');

        if(this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
            return;
        }
        //let controlType = this.controlTypeDict[menu.value];
        if( Dyn.plotView.plotShaper.hasElement( controlType ) ){
            Dyn.plotView.removePlot( controlType );
        } else {
            Dyn.plotView.addPlot( new plotElementConstructor( Dyn ) /*e.g. new Dyn.BarElement()*/ );
            // track the plot creation event
            _gaq.push(['_trackEvent', 'Plot Function', 'Click', menu.value]);
        }
    }

    // handle a click on a button that adds or removes or modifies a Dyn.PlotElement in the plot.
    modifyTogglePlotClick = ( menu, method, plotElementConstructor, controlType, baseType ) => {
        let Dyn = this.props.Dyn;
        Dyn.assert( method==='modifyToggle' ); // old menu.level===3
        Dyn.assert( typeof plotElementConstructor==='function');

        if(this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
            return;
        }
        let menuItemName = String(menu.value).replace(/[\x00-\x1F]/g, "");
        //baseType = this.baseTypeDict[menu.value],
        //controlType = this.controlTypeDict[menu.value];
        Dyn.assert( controlType && baseType );
        var existingPlotElem = Dyn.plotView.plotShaper.findElement( baseType );
        if( existingPlotElem ) {
            // modify the boolean control type in the base class, possibly removing the element entirely
            Dyn.plotView.togglePlotElement( baseType, controlType, menuItemName );
        } else {
            // if the element does not exist create it with modification
            Dyn.plotView.addPlot( new plotElementConstructor( Dyn, controlType ) );
            _gaq.push(['_trackEvent', 'Plot Function', 'Click', menu.value]);
        }
    }

    // handle a click on a button that adds Dyn.PlotElement in the plot, can add multiple times.
    addMultiplePlotClick = ( menu, method, plotElementConstructor, controlType ) => {
        let Dyn = this.props.Dyn;
        Dyn.assert( method==='addMultiple' ); // old menu.level===4
        Dyn.assert( controlType );
        Dyn.assert( typeof plotElementConstructor==='function');

        if(this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
            return;
        }
        //let controlType = this.controlTypeDict[menu.value];

        let plotElem = Dyn.plotView.plotShaper.findElement( controlType );
        if( plotElem ) {
            // use togglePlotElement to signal that we need to add to the plot element (TODO: rename togglePlotElement to something more general?)
            Dyn.plotView.togglePlotElement( controlType, null );
        } else {
            // if the element does not exist create it with modification
            Dyn.plotView.addPlot( new plotElementConstructor( Dyn, controlType ) );
            _gaq.push(['_trackEvent', 'Plot Function', 'Click', menu.value]);
        }
    }

    /** handle change to color schema */
    switchColorScheme = ( schemeName ) => {
        let Dyn = this.props.Dyn;
        Dyn.preferences.setColorScheme( schemeName );
    }

    /** handle change to animation settings */
    switchAnimationOnOff = ( value ) => {
        let Dyn = this.props.Dyn;
        Dyn.preferences.setAnimationOn( value === "AnimationOn" );
    }

    /** handle change to font size preference */
    setFontSize = ( m ) => {
        let Dyn = this.props.Dyn;
        Dyn.preferences.setFontSizeMultiplier( m );
    }

    //precisionStandard = 0;
    //precisionLow = 4;
    //precisionHigh = 8;

    /** handle change to font size preference */
    setPrecision = ( p ) => {
        let Dyn = this.props.Dyn,
            oldPrecision = Dyn.preferences.getPrecision();
        switch( p ) {
        //case 'precision+LOW': Dyn.preferences.setPrecision( this.precisionLow );   break;
        //case 'precision+HIGH': Dyn.preferences.setPrecision( this.precisionHigh );   break;
        case 'precision+1': Dyn.preferences.setPrecision( oldPrecision + 1 );   break;
        case 'precision-1': Dyn.preferences.setPrecision( oldPrecision - 1 );   break;
        default:
            Dyn.preferences.setPrecision( p );
        }
 	}

 	//getPrecisionCategory = () => {
    //    let Dyn = this.props.Dyn,
    //        p = Dyn.preferences.getPrecision();
    //    if( p === 0 ) {
    //        return "STD";
    //    } else if ( p > this.precisionLow ) {
    //        return "HIGH";
    //    } else {
    //        return "LOW";
    //    }
    //}

    /** handle change to dot size preference */
    setIconSize = ( s ) => {
        let Dyn = this.props.Dyn,
            iconStyler = Dyn.plotView.plotShaper.iconStyler,
            oldSize = iconStyler.getIconSize();
        if( s === -1 ) {
            iconStyler.setIconSize( oldSize - 1 );
        } else if ( s=== 1 ) {
            iconStyler.setIconSize( oldSize + 1 );
        } else {
            iconStyler.setIconSize( s ); // absolute size, except if s===0, we reset to the default size for plots
        }
    }

    /** handle Case Icon menu items */
    setCaseIcon = ( s ) => {
        let Dyn = this.props.Dyn,
            iconStyler = Dyn.plotView.plotShaper.iconStyler,
            mediator = this.props.Dyn.mediator;
        if( s === "caseIconCustom" ) {
            iconStyler.setCustomCaseIconEnabled( true );
            mediator.publish( "toolBar:enableDisableCustomIcon", {} );
        } else if( s === "caseIconCircle" ) {
            iconStyler.setCustomCaseIconEnabled( false );
            mediator.publish( "toolBar:enableDisableCustomIcon", {} );
        } //else if( s === "editCustomIcon" ) {
            // launch editor here, e.g. http://jxnblk.com/paths
        //}
    }

    showHideLabelsOnStats = () => {
        let Dyn = this.props.Dyn,
            plotShaper = Dyn.plotView.plotShaper;
        if( plotShaper ) {
            // toggle visible labels on all averages
            plotShaper.showHideLabelsOnStats( ! plotShaper.showLabelsOnStats );
            Dyn.mediator.publish( "toolBar:showHideLabelsOnStats", { showLabelsOnStats:plotShaper.showLabelsOnStats } );
        }
    }

    showHideSquaresOnLines = () => {
        let Dyn = this.props.Dyn,
            plotShaper = Dyn.plotView.plotShaper;
        if( plotShaper ) {
            Dyn.mediator.publish( "plot:updateAdornment", { toggleShowSquaresOnLines:true } );
        }
    }

    // To close the menu when touch happens outside the toolbar component
    handleClick = ( e ) => {
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            this.resetOpenedMenus();
        }
    }

    resetOpenedMenus = () => {
        if(this.state.openedMenus.length > 0) {
            this.setState({
                openedMenus: []
            });
        }
    }

    componentWillUnmount = () => {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
        document.removeEventListener('touchstart', this.handleClick, false);
    }

    // Common click event handler for all menu buttons
    handleMenuItemClick = (e, menu, level) => {
        e.preventDefault();
        e.stopPropagation();

        // To close menu's upon selection
        this.toolbar.clearOpened();

        // Remove focus from anchor tag when user clicks using mouse
        if(e.target.tagName.toLowerCase() === 'i') {
            e.target.parentNode.blur();
        } else {
            e.target.blur();
        }

        let Dyn = this.props.Dyn;
        let mediator = this.props.Dyn.mediator;
        // Don't proceed furthur if a menu items is not having value for the property value.
        // It helps to filter parent level menu clicks (these menus are used only for expanding submenus)
        if(menu.groupId) {
            if(Dyn.environment.isTouchDevice()) {
                // Remove focus from anchor tag when user clicks using mouse
                let openedMenus = this.state.openedMenus || [];
                // To set correct length
                openedMenus.length = level;
                openedMenus.push(menu.groupId);
                this.setState({
                    openedMenus: openedMenus
                });
            }
            return;
        } else {
            // To collapse opened menus
            this.resetOpenedMenus();
        }

        // attach clickhandler
        if( menu.value === 'Mixup' ){
        	this.mixupClick(menu);
        // Save the plot as image (PNG)
        } else if( menu.value === 'ImagePNG' ) {
            // this.savePlotAsPNGImage(false);
            // Allow screenshot only when plotview exists, not for play view
            if(Dyn.plotView) {
                this.props.onCaptureImage(e);
            }
            // Save the plot as image (SVG)
        // } else if( menu.value === 'ImageSVG' ){
        //     this.savePlotAsSVGImage();
            // Save the interactive plot
        // } else if ( menu.value === 'Save' ){
        //     this.savePlotClick();
        } else if ( menu.value === 'Support' ){
            this.openToolSupport();
        } else if ( menu.value === 'SupportGuide' ){
            this.openToolUserGuide();
        } else if ( menu.value === 'Tutorials' ){
            this.openToolTutorials();
        } else if( menu.value === 'excludeSelected' ){
            this.excludeSelected();
        } else if( menu.value === 'keepSelected' ){
            this.keepSelected();
        } else if( menu.value === 'clearAllRefLines' ){
            this.clearAllRefLines(menu);
        } else if( menu.value === 'resetAllFilter' ){
            this.resetAllFilter(menu);
        // } else if( menu.value === 'AnnotatePencilTool' ){
        //     this.startStopAnnotationClick(menu, Dyn.EAnnotationType.kPencilAT);
        // } else if( menu.value === 'AnnotateRectTool' ){
        //     this.startStopAnnotationClick(menu, Dyn.EAnnotationType.kRectAT);
        // }  else if( menu.value === 'AnnotateCircleTool' ){
        //     this.startStopAnnotationClick(menu, Dyn.EAnnotationType.kCircleAT);
        // } else if( menu.value === 'AnnotateArrowTool' ) {
        //     this.startStopAnnotationClick(menu, Dyn.EAnnotationType.kArrowAT);
        // } else if( menu.value === 'AnnotateStraightLineTool' ) {
        //     this.startStopAnnotationClick(menu, Dyn.EAnnotationType.kStraightLineAT);
        // } else if( menu.value === 'AnnotateTextTool' ){
        //     this.startStopAnnotationClick(menu, Dyn.EAnnotationType.kTextAT);
        } else if( menu.value === 'clearAllAnnotations' ){
            this.clearAllAnnotations(menu);
        } else if( menu.value === 'undo' || menu.value === 'redo' || menu.value === 'reloadPlot'){
            this.undoRedoClick( menu );
        } else if (menu.value === 'copy'){
            this.copyAnnotation();
        } else if (menu.value === 'paste'){
            this.pasteAnnotation();
        } else if( menu.value === 'randomSample' ){
            mediator.publish( "toolBar:randomSample", { } );
            _gaq.push(["_trackEvent", "Plot Function", "Click", "RandomSampleFromToolbar"]);
        } else if( menu.value === 'modelFunction' ){
            mediator.publish( "toolBar:modelFunction", { } );
            _gaq.push(["_trackEvent", "Plot Function", "Click", "ModelFunctionFromToolbar"]);
        // } else if( menu.value === 'sytleSettings' ){
        //     mediator.publish( "toolBar:styleSettings", { } );
        //     _gaq.push(["_trackEvent", "Plot Function", "Click", "StyleSettingsFromToolbar"]);
        } else if( menu.value === 'filterByAttribute' ){
            if(menu.id) {
                mediator.publish( "toolBar:filterByAttribute", { attributeId: menu.id } );
                _gaq.push(["_trackEvent", "Plot Function", "Click", "AttributeFilterFromToolbar"]);
            }
        } else if( menu.value === 'orderByAttribute' ) {
            if(menu.id && !this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
                mediator.publish( "toolBar:orderByAttribute",{ id: menu.id } );
                _gaq.push(["_trackEvent", "Plot Function", "Click", "orderCasesFromToolbar"]);
            }
        } else if(menu.value === 'filteredAttributeCases'){
            // Pass the message
            mediator.publish( "records:caseFilterByAttribute", {
                "attributeID": menu.id
            });
        } else if(menu.value === 'excludedCases') {
            // handle reset of the marquee select excluded cases
            Dyn.dataSet.caseFilter.resetFilterByExcludedCases();
        } else if(menu.value === 'sampledCases'){
            // handle reset of the random sample of cases
            Dyn.dataSet.caseSampler.resetRandomSampling();
        } else if(menu.value === 'PlotFunction') {
            // Pass the message
            mediator.publish( "toolBar:openModelFunctions" );
        // } else if(menu.value === 'styleSettings') {
        //     // Pass the message
        //     mediator.publish( "toolBar:openStyleSettings" );
        } else if(menu.value === 'PlotSettings') {
            mediator.publish( "toolBar:openPlotSettings" );
        } else if(menu.value === 'AccessibilitySettings') {
            mediator.publish( "toolBar:openAccessibilitySettings" );
        } else if(menu.value === 'KeyboardShortcuts') {
            mediator.publish( "toolBar:showKeyboardShortcuts" );
        } else if(menu.group === 'language') {
            this.props.switchLanguage( menu.value );
        } else if(menu.group === 'colorSchemeGroup' ) {
            this.switchColorScheme( menu.value );
        } else if(menu.group === 'animation' ) {
            this.switchAnimationOnOff( menu.value );
        } else if(menu.group === 'theme' ) {
            this.props.switchTheme( menu.value );
        } else if(menu.group === 'fontSizeGroup' ) {
            this.setFontSize( menu.value );
        } else if(menu.group === 'precisionGroup' ) {
            this.setPrecision( menu.value );
        } else if(menu.group === 'iconSizeGroup' ) {
            if( !this.getIsDisabledAndUpdateMenuItemTitle(menu)) {
                this.setIconSize( menu.value );
            }
        } else if(menu.group === 'caseIconGroup' ) {
            if( !this.getIsDisabledAndUpdateMenuItemTitle( menu ) ) {
                this.setCaseIcon( menu.value );
            }
        } else if( menu.value === 'ShowHideLabelsOnStats' ) {
            this.showHideLabelsOnStats();
        } else if( menu.value === 'ShowHideSquaresOnLines' ) {
            this.showHideSquaresOnLines();
        } else {
            let action = this.menuItemToPlotAction( menu );
            switch( action.m ) {
                case 'add': // like a radio button, click just adds that plot element (and removes incompatible elements)
                    this.addPlotClick( menu, action.m, action.c, action.t, action.extraType, action.extraElement );
                    break;
                case 'addRemove': // like a checkbox, click adds or removes plot element
                    this.addRemovePlotClick( menu, action.m, action.c, action.t );
                    break;
                case 'modifyToggle': // like a checkbox on an option, click adds the base element if needed, then toggles the option on/off
                    this.modifyTogglePlotClick( menu, action.m, action.c, action.t, action.baseType );
                    break;
                case 'addMultiple': // click to add the element, then click again to add more (does not remove element)
                    this.addMultiplePlotClick( menu, action.m, action.c, action.t );
                    break;
                case 'annotate': // start or stop drawing of AnnotatePencilTool, etc.
                    this.startStopAnnotationClick( menu, Dyn.AnnotationObject.controlTypeToAnnotationType( action.t ));
            }
        }
        // else if( /^debug-test-.*/.test( menu.value )) {
        //     this.handleDebugTestClick( menu );
        // }
    };

    // Handle any temporary menu items for debugging and testing.
    // handleDebugTestClick = ( menu ) => {
    //     let Dyn = this.props.Dyn;
    //     Dyn.assert( /^debug-test-.*/.test( menu.value ));
    //     switch( menu.value ) {
    //         // Developers should add and remove cases as needed:
    //         case 'debug-test-x-axis-max': {
    //             // get the current axis min and max values
    //             let axisData = {
    //                 rangeX: Dyn.plotView.xAxis.getNumericAxisRange(),
    //                 rangeY: Dyn.plotView.yAxis.getNumericAxisRange(),
    //             }
    //             // change the x-axis range if it is numeric
    //             if( axisData.rangeX.isFinite()) {
    //                 axisData.rangeX.max = Dyn.dataUtil.randomPick( 50 );
    //             }
    //             // publish the changes if any.  If no changes or changed
    //             // axis is not a numeric axis, request will be ignored.
    //             // If changed, Gear Menu > Undo Adjust Axis will be set.
    //             Dyn.mediator.publish( "axis:setMinMax", axisData );
    //         }   break;
    //         case 'debug-test-y-axis-min': {
    //             let axisData = {
    //                 rangeX: Dyn.plotView.xAxis.getNumericAxisRange(),
    //                 rangeY: Dyn.plotView.yAxis.getNumericAxisRange(),
    //             }
    //             axisData.rangeY.min = Dyn.dataUtil.randomPick( 5 );
    //             Dyn.mediator.publish( "axis:setMinMax", axisData );
    //         }   break;
    //         default:
    //             Dyn.assert( false, "handleDebugTestClick() found unknown menu.value: '"+menu.value+"'");
    //     };
    // };

    /*
    // Group/Regroup the toolbar menu items based on available width
    static resetToolbarMenuItems(menus, language, availableWidth, mode) {
        // Group/Regroup Graphs Toolbar
        var firstLevelWidth = 780, // For moving graph menu items under "Graphs"
            secondLevelWidth = 530; // For moving "Annotate & Save" inside "More Options"

        switch(language) {
            case 'es': //'Spanish'
            case 'de': //'German'
                firstLevelWidth = 880;
                secondLevelWidth = 550;
                break;
            case 'fr': // French
                firstLevelWidth = 750;
                secondLevelWidth = 480;
                break;
            case 'ar-SD': // 'Arabic'
                firstLevelWidth = 700;
                secondLevelWidth = 450;
                break;
            default: // 'en-US'
                // if mode is on, the menu doesn't take full width as default
                firstLevelWidth = mode ? 300 : firstLevelWidth;
                secondLevelWidth = secondLevelWidth;
                break;
        }

        // Go for dynamic menu grouping only when there are no mode
        if(!mode) {
            // To group/regroup the graph menu items
            let GRAPH_MENU_INDEX = mode ? 0 : 2;

            if(availableWidth < firstLevelWidth) {
                // Group Graphs
                if(menus[GRAPH_MENU_INDEX].groupId !== 'graphs') {
                    let graphsChildren = menus.filter((menu) => {
                        return menu.dynamicGroup === 'graphs';
                    });

                    // To remove the graphs buttons
                    menus.splice(GRAPH_MENU_INDEX, graphsChildren.length);
                    // Add removed graphs buttons under Graphs button
                    menus.splice(GRAPH_MENU_INDEX, 0, {
                        label: 'Graphs',
                        groupId: 'graphs',
                        children: graphsChildren
                    });
                }

                // Group More
                if(availableWidth < secondLevelWidth) {
                    let moreChildren = menus.filter((menu) => {
                        return menu.dynamicGroup === 'more';
                    });
                    let MORE_MENU_INDEX = 9;
                    // To remove the graphs buttons
                    menus.splice(MORE_MENU_INDEX, moreChildren.length);
                    // Add removed graphs buttons under Graphs button
                    menus.splice(MORE_MENU_INDEX, 0, {
                        label: 'More',
                        groupId: 'more',
                        children: moreChildren
                    });
                }
            }
        }

        return {
            menus,
            spacerClassName: this.getSpacerClassName(mode, availableWidth, firstLevelWidth, secondLevelWidth)
        };
    }

    // Method to return spacer class name based on available with, first and second level width
    static getSpacerClassName(mode, availableWidth, firstLevelWidth, secondLevelWidth) {
        if(mode) {
            return;
        }
        // Adjust spacing without grouping menu's
        //
        // 16px = Node
        // 12px = tde-space1
        // 8px = tde-space1
        //
        // Logic to set spacerClassName
        // When availableWidth is:
        // >=1150 = 16px
        // <1150 = 12px
        // <950 = 8px
        // <780 = 16px & Group Graphs Menu
        // <770 = 12px
        // <650 = 8px
        // <530 = 12px & Group More Menu
        // <515 = 8px
        var spacerClassName;
        if(availableWidth >= firstLevelWidth) {
            if(availableWidth < 950) {
                spacerClassName = 'tde-space2';
            } else if (availableWidth < 1150) {
                spacerClassName = 'tde-space1';
            }
        } else if(availableWidth >= secondLevelWidth) {
            if(availableWidth < 650) {
                spacerClassName = 'tde-space2';
            } else if (availableWidth < 770) {
                spacerClassName = 'tde-space1';
            }
        } else {
            if(availableWidth < 515) {
                spacerClassName = 'tde-space2';
            } else if (availableWidth < 530) {
                spacerClassName = 'tde-space1';
            }
        }
        return spacerClassName;
    }
    */

    // Recursively check whether a menuitem is active or not.
    // Active menuItem object in the given menuItem tree will be returned.
    getActiveItemInTree = (menuItem) => {
        let Dyn = this.props.Dyn,
            plotView = this.state.plotView,
            isTheMenuItemActive = false,
            groupIDforParentNotActive = [ // don't show the parent of these submenus as active
            'annotate',
            'languages',
            'animation',
            'fontSizeGroup',
            'iconSizeGroup',
            'caseIconGroup',
            'colorSchemeGroup',
            'precisionGroup'];
        if(!this.state.plotView) {
            return null;
        }
        if(menuItem.value === 'modelFunction' && (this.state.highlightModelFunction || Dyn.FunctionUtil.hasFormulas())) {
            isTheMenuItemActive = true;
        } else if(menuItem.value === 'randomSample' && this.props.sampleMode.isSampleMode) {
            isTheMenuItemActive = true;
        } else if(menuItem.value === 'Mixup') {
            isTheMenuItemActive = false;
        } else if(menuItem.children && ( ! groupIDforParentNotActive.includes( menuItem.groupId ))
            ) {
            for (let childMenu of menuItem.children) {
                const activeItem = this.getActiveItemInTree(childMenu);
                if(activeItem) {
                    return activeItem;
                }
                // const isActive = this.getActiveItemInTree(childMenu);
                // if(isActive) {
                //     if(typeof isActive === 'object') {
                //         return isActive;
                //     } else {
                //         return childMenu;
                //     }
                // }
            }
            return null;
        } else if(menuItem.value === "orderByAttribute" && menuItem.id) {
            isTheMenuItemActive = this.state.orderedAttributeId === menuItem.id;
        } else if(['filteredAttributeCases', 'excludedCases', 'sampledCases'].indexOf(menuItem.value) >=0) {
            isTheMenuItemActive = true;
        } else if(menuItem.group === 'language') {
            isTheMenuItemActive = this.props.language === menuItem.value;
        } else if(menuItem.group === 'colorSchemeGroup') {
            isTheMenuItemActive = menuItem.value === Dyn.preferences.getColorScheme();
        } else if(menuItem.group === 'fontSizeGroup') {
            isTheMenuItemActive = menuItem.value === Dyn.preferences.getFontSizeMultiplier();
        //} else if(menuItem.value == 'precision+LOW') {
        //    isTheMenuItemActive = this.getPrecisionCategory() === "LOW";
        //} else if(menuItem.value == 'precision+HIGH') {
        //    isTheMenuItemActive = this.getPrecisionCategory() === "HIGH";
        } else if(menuItem.group === 'precisionGroup') {
            isTheMenuItemActive = menuItem.value === Dyn.preferences.getPrecision();
        } else if(menuItem.group === 'iconSizeGroup') {
            let iconStyler = plotView.plotShaper.iconStyler;
            isTheMenuItemActive = menuItem.value === iconStyler.getIconSize();
        } else if(menuItem.group === 'animation') {
            isTheMenuItemActive = ( menuItem.value === (Dyn.preferences.isAnimationOn() ? "AnimationOn":"AnimationOff"));
        } else if(menuItem.group === 'caseIconGroup') {
            let iconStyler = plotView.plotShaper.iconStyler;
            isTheMenuItemActive = ( menuItem.value === (iconStyler.isCustomCaseIconEnabled() ? 'caseIconCustom':'caseIconCircle'));
        } else {
            let controlType = this.menuItemToPlotControlType( menuItem );//this.menuItemToPlotAction( menuItem );
            if( controlType ){
                isTheMenuItemActive =  this.state.plotView?.plotShaper.hasElement( controlType );
            }
        }
        if(isTheMenuItemActive) {
            return menuItem;
        } else {
            return null;
        }
    }

    /**
     * Return true if passed menuitem is disabled. (isEnabled holds the value to return)
     * Used to get whether a menu item is disabled or not and dynamically sets some menu's label
     * @param menuItem
     * @returns {boolean}
     */
    getIsDisabledAndUpdateMenuItemTitle = ( menuItem ) => {
        let Dyn = this.props.Dyn;
        if(!this.state.plotView) {
            return false;
        }
        let plotView = this.state.plotView,
            plotShaper = plotView.plotShaper;
        var newTitle, barCounts, pieCounts, histogramCounts, isEnabled;

        switch( menuItem.group ) {
            case "iconSizeGroup":
                isEnabled = plotShaper.allowCustomDotSize();
                break;
            case "caseIconGroup":
                // allow change if using dot plots and there is a custom case icon
                isEnabled = plotShaper.allowCustomDotSize() && plotShaper.iconStyler.hasCustomCaseIcon();
                break;
            // default: do nothing
        }
        switch( menuItem.value ) {
            //case 'precision+LOW':{
            //    let p = Dyn.preferences.getPrecision(),
            //        cat = this.getPrecisionCategory(),
            //        displayP = (cat==="LOW") ? p : this.precisionLow; // show actual precision if "low", otherwise show 4
            //    menuItem.label = Dyn.loc("{{plus}}{{p}} Precision", { plus:((displayP<0)?"":"+"), p:displayP });
            //}   break;
            //case 'precision+HIGH':{
            //    let p = Dyn.preferences.getPrecision(),
            //        cat = this.getPrecisionCategory(),
            //        displayP = (cat==="HIGH") ? p : this.precisionHigh; // show actual precision if "high", otherwise show 8
            //    menuItem.label = Dyn.loc("{{plus}}{{p}} Precision", { plus:((displayP<0)?"":"+"), p:displayP });
            //}   break;
            case 'current-precision':{
                let precision = Math.abs(Dyn.preferences.getPrecision());
                let plusminus = (precision<0)?"-":"+";
                menuItem.label = "<i>"+ `${Dyn.loc("show attribute decimals")} + ${Dyn.loc("significant digits")} ${plusminus} ${precision} ${Dyn.loc("decimal places")}` + "</i>";
                isEnabled = false;
            }   break;
            case "CellCount":
                if( hasBinsInX() || hasBinsInY()) {
                    newTitle = Dyn.loc( 'Count by Category' );
                } else {
                    newTitle = Dyn.loc( 'Count Cases' );
                }
                menuItem.label = newTitle;
                break;
            case  "SectionCount":
                // disable if not in Bar or Pie chart
                barCounts = allowBarSectionCounts('count');
                pieCounts = allowPieSectionCounts();
                histogramCounts = allowHistogramSectionCounts();
                isEnabled = barCounts || pieCounts || histogramCounts;

                if( barCounts) {
                    newTitle = Dyn.loc( isValueBarChart() ?
                        (isBarOfMeans() ? 'Means by Bar Section': 'Sum by Bar Section')
                        : 'Count by Bar Section');
                } else if ( pieCounts ) {
                    newTitle = isValuePieChart() ? Dyn.loc( 'Sum by Pie Section' ) : Dyn.loc( 'Count by Pie Section' );
                } else if ( histogramCounts ) {
                    newTitle = Dyn.loc( 'Count by Histogram Bin' );
                } else {
                    newTitle = Dyn.loc( 'Count by Section' );
                }
                menuItem.label = newTitle;
                break;
            case "SectionSum":
                // enable only if bar chart with section counts on, to sum the sections
                isEnabled = allowBarSectionCounts('sum');
                menuItem.label = isEnabled ? Dyn.loc( 'Bar Totals' ) : Dyn.loc( 'Totals' );
                break;
            case "CellPercent":
                if( hasBinsInX() || hasBinsInY()) {
                    newTitle = Dyn.loc( 'Percent by Category' );
                } else {
                    newTitle = Dyn.loc( 'Percent of Cases' );
                }
                menuItem.label = newTitle;
                break;
            case "SectionPercent":
                // disable if not in Bar, Pie, or Histogram
                barCounts = allowBarSectionCounts('%');
                pieCounts = allowPieSectionCounts();
                histogramCounts = allowHistogramSectionCounts();
                isEnabled = barCounts || pieCounts || histogramCounts;

                if( barCounts) {
                    newTitle = Dyn.loc( 'Percent by Bar Section' );
                } else if ( pieCounts ) {
                    newTitle = Dyn.loc( 'Percent by Pie Section' );
                } else if ( histogramCounts ) {
                    newTitle = Dyn.loc( 'Percent by Histogram Bin' );
                } else {
                    newTitle = Dyn.loc( 'Percent by Section' );
                }
                menuItem.label = newTitle;
                break;
            case "SectionProportion":
                // disable if not in Histogram
                //barCounts = allowBarSectionCounts('%'); // not yet
                //pieCounts = allowPieSectionCounts(); // not yet
                histogramCounts = allowHistogramSectionCounts();
                isEnabled = histogramCounts;
                if( histogramCounts ) {
                    newTitle = Dyn.loc( 'Proportion by Histogram Bin' );
                } else {
                    newTitle = Dyn.loc( 'Proportion by Section' );
                }
                menuItem.label = newTitle;
                break;
            case "OverallPercent":
                // enable only if both Row and Column bins
                isEnabled = hasBinsInX() && hasBinsInY();
                break;
            case "ColPercent":
                // enable only if both Row and Column bins
                isEnabled = hasBinsInX() && hasBinsInY();
                break;
            case "RowPercent":
                // enable only if both Row and Column bins
                isEnabled = hasBinsInX() && hasBinsInY();
                break;
            case "Mean":
                isEnabled = hasNumberLineAnyAxis();
                break;
            case "Median":
                isEnabled = hasNumberLineAnyAxis();
                break;
            case "Mode":
                isEnabled = hasNumberLineAnyAxis();
                break;
            case 'MeanAvDev':
            case "StDev":
            case "Variance":
            case "IQR":
            case 'StdError':
                isEnabled = hasNumberLineAnyAxis();
                break;
            case "PopulationMean":
            case "PopulationMedian":
            case "PopulationStDev":
            case "PopulationVariance":
            case "PopulationIQR":
                isEnabled = this.props.sampleMode.isSampleMode && hasNumberLineAnyAxis();
                break;
            case "LeastSquares":
            case "LeastSqByAttribute":
            case "LeastSqByCategory":
                // require numberline on both axes
                isEnabled = plotView.xAxis.isNumberLineAxis() &&
                plotView.yAxis.isNumberLineAxis();
                break;
            case "Dividers":		// require numberline on X axis
                isEnabled = plotView.xAxis.isNumberLineAxis();
                break;
            case 'DiagRefLineY2':
            case 'Y2RefLine':
                isEnabled = Dyn.preferences.wantY2Axis();
                break;
            case "orderByAttribute": {
                // NOTE: child menu items (which are attribute names), have menuItem.value == "orderByAttribute" also.
                if( menuItem.children ) {  // rename parent menu item only
                    if( plotShaper.isCustomOrderForLines() ) {
                        newTitle = Dyn.loc( 'Order Lines By' );
                    } else {
                        newTitle = Dyn.loc( 'Order Cases By' );
                    }
                    menuItem.label = newTitle;
                }
                // isEnabled = plotShaper.allowCustomOrderBy();
                isEnabled = plotShaper.allowCustomOrderBy();
            }   break;
            case "clearAllAnnotations":
                isEnabled = plotShaper.findElement( Dyn.EPlotControl.kControlsAnnotations );
                break;
            case "clearAllRefLines":
                isEnabled = plotShaper.findElement( Dyn.EPlotControl.kControlsRefLine );
                break;
            case "undo":
                if(Dyn.undoManager.getUndoActionString()) {
                    newTitle = Dyn.loc( "Undo {{step}}", { "step": Dyn.undoManager.getUndoActionString() });
                } else {
                    newTitle = Dyn.loc( "Undo" );
                }
                menuItem.label = newTitle;
                isEnabled = Dyn.undoManager.hasUndoSteps();
                break;
            case "redo":
                if(Dyn.undoManager.getRedoActionString()) {
                    newTitle = Dyn.loc( "Redo {{step}}", { "step": Dyn.undoManager.getRedoActionString() });
                } else {
                    newTitle = Dyn.loc( "Redo" );
                }
                menuItem.label = newTitle;
                isEnabled = Dyn.undoManager.hasRedoSteps();
                break;
            case "reloadPlot":
                isEnabled = Dyn.undoManager.hasUndoSteps() && plotView.hasSavedPlotState();
                break;
            case 'ShowHideLabelsOnStats':
                if( plotShaper.showLabelsOnStats ) {
                    newTitle = Dyn.loc( "Hide Labels" );
                } else {
                    newTitle = Dyn.loc( "Show Labels" );
                }
                menuItem.label = newTitle;
                isEnabled = true;
                break;
            case 'ShowHideSquaresOnLines':
                if( plotShaper.showSquaresOnLines ) {
                    newTitle = Dyn.loc( "Hide Squares" );
                } else {
                    newTitle = Dyn.loc( "Show Squares" );
                }
                menuItem.label = newTitle;
                isEnabled = plotShaper.hasElement( Dyn.EPlotControl.kControlsShowSquares );
                break;
            // default: do nothing
        }

        function hasBinsInX() {
            return ( plotShaper.bins && plotShaper.bins.xBins.length >= 2 );
        }
        function hasBinsInY() {
            return ( plotShaper.bins && plotShaper.bins.yBins.length >= 2 );
        }
        function allowBarSectionCounts(type) {
            var barElem = plotShaper.findElement( Dyn.EPlotControl.kControlsBarChart );
            return barElem && barElem.allowBarSectionCounts(type);
        }
        function allowHistogramSectionCounts() {
            var histogramElem = plotShaper.findElement( Dyn.EPlotControl.kControlsHistogram );
            return histogramElem && histogramElem.allowHistogramSectionCounts();
        }
        function allowPieSectionCounts() {
            var pieElem = plotShaper.findElement( Dyn.EPlotControl.kControlsPieChart );
            return pieElem && pieElem.allowPieSectionCounts();
        }
        function isValueBarChart() {
            var barElem = plotShaper.findElement( Dyn.EPlotControl.kControlsBarChart );
            return barElem && barElem.isValueBarChart();
        }
        function isBarOfMeans() {
            return plotShaper.hasElement( Dyn.EPlotControl.kControlsBarChartOfMeans );
        }
        function isValuePieChart() {
            var pieElem = plotShaper.findElement( Dyn.EPlotControl.kControlsPieChart );
            return pieElem && pieElem.isValuePieChart();
        }
        function hasNumberLineAnyAxis() {
            return plotView.xAxis.isNumberLineAxis() ||
            plotView.yAxis.isNumberLineAxis();
        }
        //function displayOrderBy() {
        //    var shapingElement = plotShaper.findElement( Dyn.EPlotControl.kControlsCaseOrder );
        //    return shapingElement && shapingElement.displayOrderBy();
        //}

        return isEnabled !== undefined && !isEnabled;
    }

    // To fill dynamic columns into respective positions of state.menu
    fillColumnsPropsIntoMenu = (menus) => {
        let Dyn = this.props.Dyn;
        menus.forEach((menu) => {
            if(!menu.fillColumns && menu.children && menu.children.length > 0) {
                this.fillColumnsPropsIntoMenu(menu.children);
            } else if(menu.fillColumns) {
                let _columns = this.props.columns.map((column, index) => {
                    if (Dyn.dataSet.attribs[index] && Dyn.dataSet.attribs[index].isVisible){
                        return {
                            label: column.name,
                            value: menu.groupId === 'filterBy'? 'filterByAttribute': 'orderByAttribute',
                            id: column.id
                        }
                    }
                });
                if ( menu.groupId === 'filterBy' ) {
                    _columns.splice(0, 1); // remove the first one (Case)
                }
                // remove the undefined ones - the one which are hidden
                menu.children = _columns.filter(function (el) { return el != null; });
            }

            // To add the excluded cases menus
            if(menu.groupId === 'filterOptions') {
                // Remove the previously filtered items if any
                menu.children = menu.children.filter((menu) => {
                    return ['filteredAttributeCases', 'excludedCases', 'sampledCases'].indexOf(menu.value) === -1;
                });
                // Add newly filtered items
                this.state.casesExcluded.forEach((caseExcluded, index) => {
                    menu.children.splice(4+index, 0, caseExcluded);
                });
            }

            // To add the dual axis (Y2) menu items
            // TODO: for #1299, delete this entire block if we decide to use static menus instead of dynamic menus
            const useStaticSubmenusInsteadOfInsert = true;
            const menuItemsForY2 = [
                {
                    groupId: 'lines',
                    insertIndex: 3,
                    menuItem: {
                        label: 'Add Reference Line on Y2',
                        value: 'Y2RefLine',
                        level: 4
                    }
                },
                {
                    groupId: 'models',
                    insertIndex: 3,
                    menuItem: {
                        label: 'Add Movable Line on X - Y2',
                        value: 'DiagRefLineY2',
                        level: 4
                    }
                },
            ];
            if ( useStaticSubmenusInsteadOfInsert ) {
                // do nothing
            } else if( this.state.showY2AxisMenuItems ) {
                // add the Y2 menu items from this menu
                menuItemsForY2.forEach( itemForY2 => {
                    if( menu.groupId === itemForY2.groupId &&
                        ! menu.children.some( child =>  child.value === itemForY2.menuItem.value )) {
                        menu.children.splice( itemForY2.insertIndex, 0, itemForY2.menuItem );
                        if (itemForY2.groupId === "lines" && menu.children.find(item => item.value === "YRefLine")) {
                            menu.children.find(item => item.value === "YRefLine").label = "Add Reference Line on Y1";
                        } else if (itemForY2.groupId === "models" && menu.children.find(item => item.value === "DiagRefLine")){
                            menu.children.find(item => item.value === "DiagRefLine").label = "Add Movable Line on X - Y1";
                        }
                    }
                });
            } else {
                // remove the Y2 menu items from this menu
                menuItemsForY2.forEach( itemForY2 => {
                    if( menu.groupId === itemForY2.groupId ) {
                        menu.children = menu.children.filter((menu) => {
                            return menu.value !== itemForY2.menuItem.value;
                        });
                        if (itemForY2.groupId === "lines" && menu.children.find(item => item.value === "YRefLine")) {
                            menu.children.find(item => item.value === "YRefLine").label = "Add Reference Line on Y";
                        } else if (itemForY2.groupId === "models" && menu.children.find(item => item.value === "DiagRefLine")){
                            menu.children.find(item => item.value === "DiagRefLine").label = "Add Movable Line on X - Y";
                        }
                    }
                });
            }
        });
    }

    /*
    populationStatsStatus = (menus) => {
        // check current mode - if sample mode ? Enable : disable
        if (!menus){
            menus = this.state.menus;
        }

        menus.forEach((menu) => {

            if( menu.sampleOnly ) {
                if ( this.props.sampleMode.isSampleMode ) {

                } else {

                }
            }

            if(menu.sampleOnly && menu.children && menu.children.length > 0) {
                this.populationStatsStatus(menu.children);
            }
        };
    }
    */

    hideSampleStatsOptions = (menu) => {
        return ( menu.sampleOnly === true && !this.props.sampleMode.isSampleMode);
    }

    // To populate all menu items based on the state.menu definition
    getMenuItem = (menu, index, level, id) => {
        let _id = (id? id + '_': '') + level + '-' + index;
        if(menu.type==='divider') {
            return <Divider key={_id}></Divider>
        } else {
            var _class = menu.children && menu.children.length ? 'tde-dropdown':'';
            if(_class && level > 0) {
                _class += '-submenu';
            }
            // Get active menu item in the given menu item tree
            let activeMenuItemInTree = this.getActiveItemInTree(menu),
                setCurrentMenuActive = activeMenuItemInTree && !menu.needActiveChildHint;

            // Don't set active for the menu "More" when the only active child is a language menu
            if(menu.groupId == 'More' && activeMenuItemInTree && activeMenuItemInTree.group === 'language') {
                setCurrentMenuActive = false;
            }

            // Don't set active for annotation items, all value starts with annotation text
            if(menu.value && menu.value.startsWith('Annotate')) {
                setCurrentMenuActive = false;
            }

            // add ARIA-haspopup=True to the screenshot button
            if(menu.value && menu.value === 'ImagePNG') {
                menu.ariaHaspopup = 'true';
            }

            const isDisabled = this.getIsDisabledAndUpdateMenuItemTitle(menu);

            _class += ' tde-cell'
            _class += (_class?' ': '') + (setCurrentMenuActive?'tde-active':'');
            _class += (_class?' ': '') + (menu.groupId && this.state.openedMenus.indexOf(menu.groupId) >= 0? 'open' : '');
            _class += (_class?' ': '') + (isDisabled?'tde-disabled':'');

            let isMac = navigator.appVersion.indexOf("Mac")!=-1 ;
            let shortcutKey = !!menu.shortcutKey ? ' ('+(isMac ? menu.shortcutKey.mac : menu.shortcutKey.windows)+')' : '';
            let menuTip = !!menu.tip ? this.getLoc(menu.tip) + shortcutKey : menu.tip;
            if(menu.children && menu.children.length > 0) {
                // Add submenu component reference for open via keyboard shortcuts
                if(!this.submenus[menu.groupId]) {
                    this.submenus[menu.groupId] = {id: null, ele: null};
                }
                this.submenus[menu.groupId]['id'] = _id;
                // Set pressed effect for Undo/Redo menu
                if(level === 0 && menu.groupId === 'undoredo') {
                    _class += ' tde-pressed';
                }
                return (<SubMenu key={_id} id={_id}
                    ref={ele => this.submenus[menu.groupId]['ele'] = ele}
                    tip={this.getLoc(menu.tip)}
                    mode={this.props.mode}
                    container={this.props.toolsContainer}
                    label={this.renderMenuLabel(menu, level, activeMenuItemInTree)}
                    className={_class} data-level={level} aria-label={menuTip || ''}
                    {...(menu.ariaHaspopup && { 'aria-haspopup': menu.ariaHaspopup })}>
                    {menu.children.map((_menu, _index) =>
                        this.getMenuItem(_menu, _index, level+1, _id)
                    ).filter(function(menu){return menu != undefined})}
                </SubMenu>)
            } else {
                const menuItemLabel = this.renderMenuLabel(menu, level, activeMenuItemInTree);
                // Set pressed effect for Mixup menu
                if(level === 0 && menu.value === 'Mixup') {
                    _class += ' tde-pressed';
                }
                const menuItem = <MenuItem key={_id} id={_id} className={_class}
                    onClick={(e) => this.handleMenuItemClick(e, menu, level)}
                    data-level={level} aria-label={menuTip || ''} aria-disabled={isDisabled}
                    {...(menu.ariaHaspopup && { 'aria-haspopup': menu.ariaHaspopup })}>
                    {menuItemLabel}
                </MenuItem>
                if(menuTip && level === 0) {
                    // Adding tooltip
                    return <ToolTip tip={menuTip} key={_id} Dyn={this.props.Dyn}>{menuItem}</ToolTip>;
                } else {
                    return menuItem;
                }
            }
        }
    }

    replaceWithIcon = (str, key, iconClass) => {
        if(str.indexOf(key) === 0) {
            return <span><i className={"tde-i tde-s2 " + iconClass}></i>{str.substr(key.length)}</span>;
        } else {
            return <span>{str}</span>;
        }
    }
    /**
     * Rendering label for a given menu
     * @param {*} menu
     * @param {*} level
     * @param {*} activeMenuItemInTree
     */
    renderMenuLabel (menu, level, activeMenuItemInTree) {
        const _requireJrMode = requireJrMode(this.props.mode);
        let className = "tde-s1 " + (level == 0 ? " tde-d-flex tde-fill tde-flex-direction-col tde-justify-center " + (menu.cssClassNames || ''): ' tde-d-flex tde-justify-space-between');
        let labelName;
        let isMac = navigator.appVersion.indexOf("Mac")!=-1 ;
        if(menu.label === '+0 Decimal Places (Standard)'){
            labelName = `+${this.getLoc('0 Decimal Places (Standard)')}`;
        }else if(menu.label === '+4 Decimal Places'){
            labelName = `+${this.getLoc('4 Decimal Places')}`;
        }else if(menu.label === '+8 Decimal Places'){
            labelName = `+${this.getLoc('8 Decimal Places')}`;
        }else{
            labelName = menu.label;
        }
        let labelEle;
        if(_requireJrMode && level === 0){
            labelEle = (<div className={className}>
                {menu.iconClass && <i className={menu.iconClass}></i>}
                {menu.label && <label>{menu.label}</label>}
            </div>);
        } else {
            // Set tip as label when menu level is greater than 0 and label name is empty
            if(!labelName && level > 0) {
                labelName = menu.tip;
            }
             labelEle = (<div className={className}><span>
                {menu.iconClass && <i className={menu.iconClass}></i>}
                {/* Add empty space between icon and label */}
                {menu.iconClass && level > 0 && labelName && <span> </span>}
                {/* Show label only when there are no icon or level is more than zero when both icon and label are given */}
                {(menu.iconClass && level > 0 || !menu.iconClass) && <span className={level !=0 ? "tde-pr-3" : ""}>{menu.value === 'filterByAttribute'? <Mathjax value={labelName} /> : (menu.skipLoc?labelName: this.getLoc(labelName))}</span>}
                {/* Note from active child */}
                {menu.needActiveChildHint && activeMenuItemInTree && <span> {activeMenuItemInTree.hint}</span>}
            </span>
                {/* Displaying keyboard shortcut */}
            {!!menu.shortcutKey && level > 0 && <span>
                <span className={`tde-s2 tde-pl-4 tde-no-wrap ${!activeMenuItemInTree && ' tde-cell-subtext'}`}>
                { isMac ? this.replaceWithIcon(menu.shortcutKey.mac, 'command', 'tde-i-command-key')
                        : menu.shortcutKey.windows
                }</span>
            </span>}
        </div>);
        }

        return labelEle;
    }

    openMenuGroup = (menuGroupId) => {
        if (menuGroupId) {
            let submenuObj = this.submenus[menuGroupId];
            if(submenuObj.ele) {
                submenuObj.ele.open();
            } else {
                // If the component is not mounted then
                // open it first and then give some timeout to let the component mount and then call open to focus the first child
                this.toolbar.setOpen(1, submenuObj.id);
                setTimeout(() => {
                    submenuObj.ele && submenuObj.ele.open();
                }, 200);
            }
        } else {
            this.toolbar._domNode.firstElementChild.focus();
        }
    }

    setFocus = (args) => {
        this.toolbar._domNode.firstElementChild.focus();
    }

    // Render the UI of toolbar component
    render = () => {
        const _requireJrMode = requireJrMode(this.props.mode);
        this.fillColumnsPropsIntoMenu(this.state.menus);
        // this.populationStatsStatus();
        return (
            <>
            <Menu className={"tde-plot-toolbar tde-flex-1 tde-divider-bottom" + (this.state.menuSpacerClassName?' ' + this.state.menuSpacerClassName: '')} direction="horizontal" ref={toolbar => {this.toolbar = toolbar}}>
                {this.state.menus.map((menu, index) =>
                    this.getMenuItem(menu, index, 0)
                ).filter(function(menu){return menu != undefined})}
            </Menu>
            {_requireJrMode && (
                <div className='tde-menu tde-horizontal tde-primary-text-color'>
                    <MenuItem className="tde-ml-1 tde-mr-0 tde-cell" onClick={this.props.onPlayViewClick}
                        aria-label='Switch to play view' title="Switch to play view">
                        <div className="tde-s1 "><i className="tde-i tde-i-play-view"></i><label>Play View</label></div>
                    </MenuItem>
                </div>
            )}
            </>
        )
    }
}

export default ToolbarComponent
